import React from 'react'
import { Link } from 'react-router'
import './index.less'
import { setDocumentTitle, setUidToken } from 'src/helper/tool'

export default class extends React.Component {

	async componentWillMount() {
	}

	render() {
		let gifts = [{
			"giftid": 881,
			"gold": 30,
			"name": "Happy Father's Day",
			"image": "https://falla-res1.falla.live/575685-20220610_175213_1654854733553.png",
			"svga": "",
			"music": 2,
			"gifttype": 0,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://falla-res.falla.live/575685-20220105_175141_1641376301312.png"],
			"tagBanner": {
				"tagType": 7,
				"bg": "https://falla-res1.falla.live/awss3_575685_1655441506703285571_4095954802.png",
				"content": ".",
				"jumpUrl": "https://web.falla.live/falla-web/micro-main/index.html#/act-father-day/invitation",
				"extData": ""
			},
			"translationKey": "72_nitbissdjo"
		}, {
			"giftid": 882,
			"gold": 300,
			"name": "Father's hand",
			"image": "https://falla-res1.falla.live/575685-20220603_230618_1654268778310.png",
			"svga": "https://falla-res1.falla.live/575685-20220603_230620_1654268780982.svga",
			"music": 2,
			"gifttype": 1,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://falla-res.falla.live/575685-20220105_175141_1641376301312.png"],
			"tagBanner": {
				"tagType": 7,
				"bg": "https://falla-res1.falla.live/awss3_575685_1655441506703285571_4095954802.png",
				"content": ".",
				"jumpUrl": "https://web.falla.live/falla-web/micro-main/index.html#/act-father-day/invitation",
				"extData": ""
			},
			"translationKey": "72_uctgewigcp"
		}, {
			"giftid": 883,
			"gold": 3000,
			"name": "Father's love",
			"image": "https://falla-res1.falla.live/575685-20220603_230748_1654268868549.png",
			"svga": "https://falla-res1.falla.live/575685-20220603_230758_1654268878692.svga",
			"music": 2,
			"gifttype": 2,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://falla-res.falla.live/575685-20220105_175141_1641376301312.png", "https://vochatapp.thevochat.com/gift/tag/global_banner.png"],
			"tagBanner": {
				"tagType": 7,
				"bg": "https://falla-res1.falla.live/awss3_575685_1655441506703285571_4095954802.png",
				"content": ".",
				"jumpUrl": "https://web.falla.live/falla-web/micro-main/index.html#/act-father-day/invitation",
				"extData": ""
			},
			"translationKey": "72_nkpvadtwwi"
		}, {
			"giftid": 14,
			"gold": 52,
			"name": "Beer",
			"image": "https://falla-res1.falla.live/119040-20210428_161342_1619597622608.png",
			"svga": "https://falla-common.falla.live/119040-20200315_220324_1584281004803.svga",
			"music": 1,
			"gifttype": 1,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "http://res-dubai.falla.live/gift/tag/star.png",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://vochatapp.thevochat.com/gift/tag/week_star.png"],
			"tagBanner": {
				"tagType": 6,
				"bg": "https://vochatapp.thevochat.com/gift/tag/banner/week_star.png",
				"content": "",
				"jumpUrl": "https://web.falla.live/?t/?ts=1617675897#/activity/20-11-week?",
				"extData": ""
			},
			"translationKey": "key_gift_14"
		}, {
			"giftid": 270,
			"gold": 777,
			"name": "love",
			"image": "https://falla-res1.falla.live/119040-20210428_160733_1619597253595.png",
			"svga": "https://falla-res1.falla.live/119040-20201226_173325_1608975205208.svga",
			"music": 2,
			"gifttype": 1,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "http://res-dubai.falla.live/gift/tag/star.png",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://vochatapp.thevochat.com/gift/tag/week_star.png", "https://falla-res.falla.live/785404-20210929_161525_1632903325002.png"],
			"tagBanner": {
				"tagType": 6,
				"bg": "https://vochatapp.thevochat.com/gift/tag/banner/week_star.png",
				"content": "",
				"jumpUrl": "https://web.falla.live/?t/?ts=1617675897#/activity/20-11-week?",
				"extData": ""
			},
			"translationKey": "key_gift_270"
		}, {
			"giftid": 373,
			"gold": 3500,
			"name": "Ring",
			"image": "https://falla-res1.falla.live/119040-20210609_162658_1623227218151.png",
			"svga": "https://falla-res1.falla.live/119040-20210609_162702_1623227222527.svga",
			"music": 2,
			"gifttype": 2,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "http://res-dubai.falla.live/gift/tag/star.png",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://vochatapp.thevochat.com/gift/tag/week_star.png", "https://vochatapp.thevochat.com/gift/tag/global_banner.png"],
			"tagBanner": {
				"tagType": 6,
				"bg": "https://vochatapp.thevochat.com/gift/tag/banner/week_star.png",
				"content": "",
				"jumpUrl": "https://web.falla.live/?t/?ts=1617675897#/activity/20-11-week?",
				"extData": ""
			},
			"translationKey": "key_gift_373"
		}, {
			"giftid": 375,
			"gold": 15888,
			"name": "Together",
			"image": "https://falla-res1.falla.live/119040-20210610_102545_1623291945548.png",
			"svga": "https://falla-res1.falla.live/119040-20210610_102553_1623291953880.svga",
			"music": 1,
			"gifttype": 2,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "http://res-dubai.falla.live/gift/tag/star.png",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://vochatapp.thevochat.com/gift/tag/week_star.png", "https://vochatapp.thevochat.com/gift/tag/global_banner.png"],
			"tagBanner": {
				"tagType": 6,
				"bg": "https://vochatapp.thevochat.com/gift/tag/banner/week_star.png",
				"content": "",
				"jumpUrl": "https://web.falla.live/?t/?ts=1617675897#/activity/20-11-week?",
				"extData": ""
			},
			"translationKey": "key_gift_375"
		}, {
			"giftid": 899,
			"gold": 5,
			"name": "popo",
			"image": "https://falla-res1.falla.live/119040-20220613_185807_1655117887340.png",
			"svga": "https://falla-res1.falla.live/119040-20220613_185807_1655117887217.svga",
			"music": 2,
			"gifttype": 1,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": [],
			"tagBanner": null,
			"translationKey": "72_kilpjdwbrz"
		}, {
			"giftid": 900,
			"gold": 50,
			"name": "cola",
			"image": "https://falla-res1.falla.live/119040-20220613_185902_1655117942022.png",
			"svga": "https://falla-res1.falla.live/119040-20220613_185903_1655117943517.svga",
			"music": 2,
			"gifttype": 1,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": [],
			"tagBanner": null,
			"translationKey": "72_eplonqjlfw"
		}, {
			"giftid": 901,
			"gold": 55,
			"name": "atún",
			"image": "https://falla-res1.falla.live/575685-20220613_195422_1655121262270.png",
			"svga": "",
			"music": 2,
			"gifttype": 0,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": [],
			"tagBanner": null,
			"translationKey": "72_rnovophsus"
		}, {
			"giftid": 791,
			"gold": 30,
			"name": "Paloma",
			"image": "https://falla-res1.falla.live/575685-20220413_152947_1649834987586.png",
			"svga": "https://falla-res1.falla.live/575685-20220413_153043_1649835043983.svga",
			"music": 2,
			"gifttype": 1,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://falla-res.falla.live/575685-20220224_133725_1645681045362.png"],
			"tagBanner": {
				"tagType": 7,
				"bg": "https://falla-res.falla.live/575685-20220419_130229_1650344549830.png",
				"content": ".",
				"jumpUrl": "https://web.falla.live/falla-web/micro-main/index.html?debugI18n=es#/act-es-week/task",
				"extData": ""
			},
			"translationKey": "72_xtayikdvtq"
		}, {
			"giftid": 793,
			"gold": 3000,
			"name": "Cristo",
			"image": "https://falla-res1.falla.live/575685-20220413_153514_1649835314331.png",
			"svga": "https://falla-res1.falla.live/575685-20220413_153520_1649835320929.svga",
			"music": 1,
			"gifttype": 2,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://vochatapp.thevochat.com/gift/tag/global_banner.png"],
			"tagBanner": {
				"tagType": 1,
				"bg": "https://vochatapp.thevochat.com/gift/tag/banner/global_banner_en.png",
				"content": "The gift will trigger a global broadcast",
				"jumpUrl": "",
				"extData": ""
			},
			"translationKey": "72_xihbwuffve"
		}, {
			"giftid": 740,
			"gold": 3000,
			"name": "Spring Bonfire",
			"image": "https://falla-res1.falla.live/575685-20220317_225308_1647528788789.png",
			"svga": "https://falla-res1.falla.live/575685-20220317_225354_1647528834197.svga",
			"music": 2,
			"gifttype": 2,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://vochatapp.thevochat.com/gift/tag/global_banner.png"],
			"tagBanner": {
				"tagType": 1,
				"bg": "https://vochatapp.thevochat.com/gift/tag/banner/global_banner_en.png",
				"content": "The gift will trigger a global broadcast",
				"jumpUrl": "",
				"extData": ""
			},
			"translationKey": "72_dpljbsuwyw"
		}, {
			"giftid": 894,
			"gold": 50,
			"name": "Lucky key",
			"image": "https://falla-res1.falla.live/119040-20220607_152035_1654586435956.png",
			"svga": "",
			"music": 2,
			"gifttype": 0,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": [],
			"tagBanner": null,
			"translationKey": "72_kmqsstbjyj"
		}, {
			"giftid": 893,
			"gold": 4999,
			"name": "Butterfly",
			"image": "https://falla-res1.falla.live/575685-20220607_112039_1654572039132.png",
			"svga": "https://falla-res1.falla.live/575685-20220607_112043_1654572043262.svga",
			"music": 2,
			"gifttype": 2,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://vochatapp.thevochat.com/gift/tag/global_banner.png"],
			"tagBanner": {
				"tagType": 1,
				"bg": "https://vochatapp.thevochat.com/gift/tag/banner/global_banner_en.png",
				"content": "The gift will trigger a global broadcast",
				"jumpUrl": "",
				"extData": ""
			},
			"translationKey": "72_vwsidyydns"
		}, {
			"giftid": 860,
			"gold": 6999,
			"name": "Helicopter",
			"image": "https://falla-res1.falla.live/575685-20220609_175231_1654768351798.png",
			"svga": "https://falla-res1.falla.live/575685-20220528_191832_1653736712898.mp4",
			"music": 2,
			"gifttype": 2,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://vochatapp.thevochat.com/gift/tag/3d.png", "https://vochatapp.thevochat.com/gift/tag/global_banner.png"],
			"tagBanner": {
				"tagType": 4,
				"bg": "https://vochatapp.thevochat.com/gift/tag/banner/3d_en.png",
				"content": "The gift will trigger 3D animation",
				"jumpUrl": "",
				"extData": ""
			},
			"translationKey": "72_unztzjfbmm"
		}, {
			"giftid": 861,
			"gold": 29999,
			"name": "Love Island",
			"image": "https://falla-res1.falla.live/575685-20220528_192019_1653736819668.png",
			"svga": "https://falla-res1.falla.live/575685-20220528_192034_1653736834860.mp4",
			"music": 2,
			"gifttype": 2,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://vochatapp.thevochat.com/gift/tag/3d.png", "https://vochatapp.thevochat.com/gift/tag/global_banner.png"],
			"tagBanner": {
				"tagType": 4,
				"bg": "https://vochatapp.thevochat.com/gift/tag/banner/3d_en.png",
				"content": "The gift will trigger 3D animation",
				"jumpUrl": "",
				"extData": ""
			},
			"translationKey": "72_apkogkqhjj"
		}, {
			"giftid": 374,
			"gold": 350,
			"name": "Love letter",
			"image": "https://falla-res1.falla.live/119040-20210609_162820_1623227300930.png",
			"svga": "https://falla-res1.falla.live/119040-20210609_162928_1623227368708.svga",
			"music": 2,
			"gifttype": 1,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": [],
			"tagBanner": null,
			"translationKey": "key_gift_374"
		}, {
			"giftid": 318,
			"gold": 3000,
			"name": "poetry",
			"image": "https://falla-res1.falla.live/119040-20210428_161014_1619597414421.png",
			"svga": "https://falla-res1.falla.live/119040-20210309_170828_1615280908799.svga",
			"music": 2,
			"gifttype": 2,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://vochatapp.thevochat.com/gift/tag/global_banner.png"],
			"tagBanner": {
				"tagType": 1,
				"bg": "https://vochatapp.thevochat.com/gift/tag/banner/global_banner_en.png",
				"content": "The gift will trigger a global broadcast",
				"jumpUrl": "",
				"extData": ""
			},
			"translationKey": "key_gift_318"
		}, {
			"giftid": 123,
			"gold": 6000,
			"name": "piano",
			"image": "https://falla-res1.falla.live/575685-20220512_182348_1652351028499.png",
			"svga": "https://falla-res1.falla.live/575685-20220512_182430_1652351070840.svga",
			"music": 1,
			"gifttype": 2,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://vochatapp.thevochat.com/gift/tag/global_banner.png"],
			"tagBanner": {
				"tagType": 1,
				"bg": "https://vochatapp.thevochat.com/gift/tag/banner/global_banner_en.png",
				"content": "The gift will trigger a global broadcast",
				"jumpUrl": "",
				"extData": ""
			},
			"translationKey": "key_gift_123"
		}, {
			"giftid": 675,
			"gold": 18888,
			"name": "Romantic encounter",
			"image": "https://falla-res1.falla.live/785404-20220211_184930_1644576570931.png",
			"svga": "https://falla-res1.falla.live/785404-20220211_184934_1644576574659.svga",
			"music": 2,
			"gifttype": 2,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://vochatapp.thevochat.com/gift/tag/global_banner.png"],
			"tagBanner": {
				"tagType": 1,
				"bg": "https://vochatapp.thevochat.com/gift/tag/banner/global_banner_en.png",
				"content": "The gift will trigger a global broadcast",
				"jumpUrl": "",
				"extData": ""
			},
			"translationKey": "72_ndepecdasx"
		}, {
			"giftid": 557,
			"gold": 300,
			"name": "沙特亚足联赛冠军定制礼物",
			"image": "https://falla-res1.falla.live/785404-20211124_194415_1637754255741.png",
			"svga": "https://falla-res1.falla.live/785404-20211124_194417_1637754257503.svga",
			"music": 2,
			"gifttype": 1,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": [],
			"tagBanner": null,
			"translationKey": "72_xucwrssirs"
		}, {
			"giftid": 650,
			"gold": 1888,
			"name": "Happy new year",
			"image": "https://falla-res1.falla.live/785404-20220128_165805_1643360285224.png",
			"svga": "https://falla-res1.falla.live/785404-20220125_153812_1643096292606.mp4",
			"music": 2,
			"gifttype": 1,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://vochatapp.thevochat.com/gift/tag/3d.png"],
			"tagBanner": {
				"tagType": 4,
				"bg": "https://vochatapp.thevochat.com/gift/tag/banner/3d_en.png",
				"content": "The gift will trigger 3D animation",
				"jumpUrl": "",
				"extData": ""
			},
			"translationKey": "72_vmvsivlxxe"
		}, {
			"giftid": 559,
			"gold": 3000,
			"name": "鲨鱼踢球",
			"image": "https://falla-res1.falla.live/785404-20211125_174501_1637833501491.png",
			"svga": "https://falla-res1.falla.live/785404-20211125_174503_1637833503100.svga",
			"music": 2,
			"gifttype": 1,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://vochatapp.thevochat.com/gift/tag/global_banner.png"],
			"tagBanner": {
				"tagType": 1,
				"bg": "https://vochatapp.thevochat.com/gift/tag/banner/global_banner_en.png",
				"content": "The gift will trigger a global broadcast",
				"jumpUrl": "",
				"extData": ""
			},
			"translationKey": "72_xibbwmunfj"
		}, {
			"giftid": 554,
			"gold": 66,
			"name": "Snowball",
			"image": "https://falla-res1.falla.live/785404-20211124_102953_1637720993066.png",
			"svga": "https://falla-res1.falla.live/785404-20211123_153933_1637653173779.svga",
			"music": 2,
			"gifttype": 1,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": [],
			"tagBanner": null,
			"translationKey": "72_bjnetmthoh"
		}, {
			"giftid": 555,
			"gold": 299,
			"name": "Snowman CP",
			"image": "https://falla-res1.falla.live/785404-20211124_103435_1637721275611.png",
			"svga": "https://falla-res1.falla.live/785404-20211123_154335_1637653415307.svga",
			"music": 2,
			"gifttype": 1,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": [],
			"tagBanner": null,
			"translationKey": "72_rixpozmvwp"
		}, {
			"giftid": 556,
			"gold": 599,
			"name": "Snowy house",
			"image": "https://falla-res1.falla.live/785404-20211124_103053_1637721053248.png",
			"svga": "https://falla-res1.falla.live/785404-20211123_154417_1637653457390.svga",
			"music": 2,
			"gifttype": 1,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": [],
			"tagBanner": null,
			"translationKey": "72_jdiwmwxfnn"
		}, {
			"giftid": 525,
			"gold": 99,
			"name": "Microphone",
			"image": "https://falla-res1.falla.live/785404-20211104_165706_1636016226206.png",
			"svga": "https://falla-res1.falla.live/785404-20211104_165711_1636016231274.mp4",
			"music": 2,
			"gifttype": 1,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 4,
			"cp": 2,
			"vip": 1,
			"vipIcon": "http://vochatapp.thevochat.com/nobility/1_s.png",
			"tags": ["https://vochatapp.thevochat.com/gift/tag/3d.png"],
			"tagBanner": {
				"tagType": 4,
				"bg": "https://vochatapp.thevochat.com/gift/tag/banner/3d_en.png",
				"content": "The gift will trigger 3D animation",
				"jumpUrl": "",
				"extData": ""
			},
			"translationKey": "72_woototdlol"
		}, {
			"giftid": 527,
			"gold": 999,
			"name": "Stars shine",
			"image": "https://falla-res1.falla.live/785404-20211104_170027_1636016427683.png",
			"svga": "https://falla-res1.falla.live/785404-20211104_170030_1636016430156.svga",
			"music": 2,
			"gifttype": 1,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": [],
			"tagBanner": null,
			"translationKey": "72_kfeqkdehxz"
		}, {
			"giftid": 528,
			"gold": 3333,
			"name": "Gold trophy",
			"image": "https://falla-res1.falla.live/785404-20211104_170127_1636016487353.png",
			"svga": "https://falla-res1.falla.live/785404-20211104_170135_1636016495471.svga",
			"music": 2,
			"gifttype": 1,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://vochatapp.thevochat.com/gift/tag/global_banner.png"],
			"tagBanner": {
				"tagType": 1,
				"bg": "https://vochatapp.thevochat.com/gift/tag/banner/global_banner_en.png",
				"content": "The gift will trigger a global broadcast",
				"jumpUrl": "",
				"extData": ""
			},
			"translationKey": "72_ipkseyihnn"
		}, {
			"giftid": 523,
			"gold": 4999,
			"name": "Fierce tiger",
			"image": "https://falla-res1.falla.live/785404-20211104_165156_1636015916304.png",
			"svga": "https://falla-res1.falla.live/785404-20211104_165158_1636015918014.svga",
			"music": 2,
			"gifttype": 1,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://vochatapp.thevochat.com/gift/tag/global_banner.png"],
			"tagBanner": {
				"tagType": 1,
				"bg": "https://vochatapp.thevochat.com/gift/tag/banner/global_banner_en.png",
				"content": "The gift will trigger a global broadcast",
				"jumpUrl": "",
				"extData": ""
			},
			"translationKey": "72_dwkbmbmweo"
		}, {
			"giftid": 530,
			"gold": 9999,
			"name": "Sword warrior",
			"image": "https://falla-res1.falla.live/785404-20211104_170252_1636016572559.png",
			"svga": "https://falla-res1.falla.live/785404-20211104_170254_1636016574361.svga",
			"music": 2,
			"gifttype": 1,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://vochatapp.thevochat.com/gift/tag/global_banner.png"],
			"tagBanner": {
				"tagType": 1,
				"bg": "https://vochatapp.thevochat.com/gift/tag/banner/global_banner_en.png",
				"content": "The gift will trigger a global broadcast",
				"jumpUrl": "",
				"extData": ""
			},
			"translationKey": "72_tclbdioakw"
		}, {
			"giftid": 526,
			"gold": 399,
			"name": "KungFu Boxing",
			"image": "https://falla-res1.falla.live/785404-20211104_165822_1636016302887.png",
			"svga": "https://falla-res1.falla.live/785404-20211104_165826_1636016306053.mp4",
			"music": 2,
			"gifttype": 1,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 4,
			"cp": 2,
			"vip": 1,
			"vipIcon": "http://vochatapp.thevochat.com/nobility/1_s.png",
			"tags": ["https://vochatapp.thevochat.com/gift/tag/3d.png"],
			"tagBanner": {
				"tagType": 4,
				"bg": "https://vochatapp.thevochat.com/gift/tag/banner/3d_en.png",
				"content": "The gift will trigger 3D animation",
				"jumpUrl": "",
				"extData": ""
			},
			"translationKey": "72_gisptxshoo"
		}, {
			"giftid": 473,
			"gold": 27,
			"name": "Tacos",
			"image": "https://falla-res1.falla.live/119040-20210923_203939_1632400779599.png",
			"svga": "",
			"music": 2,
			"gifttype": 0,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": [],
			"tagBanner": null,
			"translationKey": "key_gift_473"
		}, {
			"giftid": 475,
			"gold": 100,
			"name": "Cactus",
			"image": "https://falla-res1.falla.live/119040-20210924_231956_1632496796900.png",
			"svga": "https://falla-res1.falla.live/119040-20210924_232004_1632496804404.svga",
			"music": 2,
			"gifttype": 1,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": [],
			"tagBanner": null,
			"translationKey": "key_gift_475"
		}, {
			"giftid": 474,
			"gold": 200,
			"name": "Tequila",
			"image": "https://falla-res1.falla.live/119040-20210924_143147_1632465107422.png",
			"svga": "https://falla-res1.falla.live/119040-20210924_143148_1632465108865.svga",
			"music": 2,
			"gifttype": 1,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": [],
			"tagBanner": null,
			"translationKey": "key_gift_474"
		}, {
			"giftid": 649,
			"gold": 9999,
			"name": "Cataratas del Iguazú",
			"image": "https://falla-res1.falla.live/119040-20220121_155129_1642751489836.png",
			"svga": "https://falla-res1.falla.live/119040-20220121_155131_1642751491205.svga",
			"music": 2,
			"gifttype": 2,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://vochatapp.thevochat.com/gift/tag/global_banner.png"],
			"tagBanner": {
				"tagType": 1,
				"bg": "https://vochatapp.thevochat.com/gift/tag/banner/global_banner_en.png",
				"content": "The gift will trigger a global broadcast",
				"jumpUrl": "",
				"extData": ""
			},
			"translationKey": "72_zxhzvexqur"
		}, {
			"giftid": 455,
			"gold": 199,
			"name": "Popcorn",
			"image": "https://falla-res1.falla.live/119040-20210928_185509_1632826509395.png",
			"svga": "https://falla-res1.falla.live/785404-20210903_173627_1630661787517.mp4",
			"music": 2,
			"gifttype": 1,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 4,
			"cp": 2,
			"vip": 1,
			"vipIcon": "http://vochatapp.thevochat.com/nobility/1_s.png",
			"tags": ["https://vochatapp.thevochat.com/gift/tag/3d.png"],
			"tagBanner": {
				"tagType": 4,
				"bg": "https://vochatapp.thevochat.com/gift/tag/banner/3d_en.png",
				"content": "The gift will trigger 3D animation",
				"jumpUrl": "",
				"extData": ""
			},
			"translationKey": "key_gift_455"
		}, {
			"giftid": 454,
			"gold": 299,
			"name": "Ice Cream",
			"image": "https://falla-res1.falla.live/119040-20210928_185525_1632826525912.png",
			"svga": "https://falla-res1.falla.live/785404-20210903_173454_1630661694486.mp4",
			"music": 2,
			"gifttype": 1,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 4,
			"cp": 2,
			"vip": 1,
			"vipIcon": "http://vochatapp.thevochat.com/nobility/1_s.png",
			"tags": ["https://vochatapp.thevochat.com/gift/tag/3d.png"],
			"tagBanner": {
				"tagType": 4,
				"bg": "https://vochatapp.thevochat.com/gift/tag/banner/3d_en.png",
				"content": "The gift will trigger 3D animation",
				"jumpUrl": "",
				"extData": ""
			},
			"translationKey": "key_gift_454"
		}, {
			"giftid": 453,
			"gold": 499,
			"name": "Glass",
			"image": "https://falla-res1.falla.live/119040-20210928_185547_1632826547515.png",
			"svga": "https://falla-res1.falla.live/785404-20210903_172809_1630661289667.mp4",
			"music": 2,
			"gifttype": 1,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 4,
			"cp": 2,
			"vip": 1,
			"vipIcon": "http://vochatapp.thevochat.com/nobility/1_s.png",
			"tags": ["https://vochatapp.thevochat.com/gift/tag/3d.png"],
			"tagBanner": {
				"tagType": 4,
				"bg": "https://vochatapp.thevochat.com/gift/tag/banner/3d_en.png",
				"content": "The gift will trigger 3D animation",
				"jumpUrl": "",
				"extData": ""
			},
			"translationKey": "key_gift_453"
		}, {
			"giftid": 452,
			"gold": 599,
			"name": "Rose",
			"image": "https://falla-res1.falla.live/119040-20210928_185603_1632826563077.png",
			"svga": "https://falla-res1.falla.live/785404-20210903_172119_1630660879482.mp4",
			"music": 1,
			"gifttype": 1,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 4,
			"cp": 2,
			"vip": 1,
			"vipIcon": "http://vochatapp.thevochat.com/nobility/1_s.png",
			"tags": ["https://vochatapp.thevochat.com/gift/tag/3d.png"],
			"tagBanner": {
				"tagType": 4,
				"bg": "https://vochatapp.thevochat.com/gift/tag/banner/3d_en.png",
				"content": "The gift will trigger 3D animation",
				"jumpUrl": "",
				"extData": ""
			},
			"translationKey": "key_gift_452"
		}, {
			"giftid": 451,
			"gold": 699,
			"name": "Champagne",
			"image": "https://falla-res1.falla.live/785404-20210903_172651_1630661211377.png",
			"svga": "https://falla-res1.falla.live/785404-20210903_172703_1630661223003.mp4",
			"music": 1,
			"gifttype": 1,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 4,
			"cp": 2,
			"vip": 1,
			"vipIcon": "http://vochatapp.thevochat.com/nobility/1_s.png",
			"tags": ["https://vochatapp.thevochat.com/gift/tag/3d.png"],
			"tagBanner": {
				"tagType": 4,
				"bg": "https://vochatapp.thevochat.com/gift/tag/banner/3d_en.png",
				"content": "The gift will trigger 3D animation",
				"jumpUrl": "",
				"extData": ""
			},
			"translationKey": "key_gift_451"
		}, {
			"giftid": 450,
			"gold": 799,
			"name": "Sword",
			"image": "https://falla-res1.falla.live/119040-20210928_185622_1632826582397.png",
			"svga": "https://falla-res1.falla.live/785404-20210903_171854_1630660734266.mp4",
			"music": 1,
			"gifttype": 1,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 4,
			"cp": 2,
			"vip": 1,
			"vipIcon": "http://vochatapp.thevochat.com/nobility/1_s.png",
			"tags": ["https://vochatapp.thevochat.com/gift/tag/3d.png"],
			"tagBanner": {
				"tagType": 4,
				"bg": "https://vochatapp.thevochat.com/gift/tag/banner/3d_en.png",
				"content": "The gift will trigger 3D animation",
				"jumpUrl": "",
				"extData": ""
			},
			"translationKey": "key_gift_450"
		}, {
			"giftid": 449,
			"gold": 999,
			"name": "Delicious Food",
			"image": "https://falla-res1.falla.live/119040-20210928_185639_1632826599017.png",
			"svga": "https://falla-res1.falla.live/785404-20210903_171644_1630660604040.mp4",
			"music": 1,
			"gifttype": 1,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 4,
			"cp": 2,
			"vip": 1,
			"vipIcon": "http://vochatapp.thevochat.com/nobility/1_s.png",
			"tags": ["https://vochatapp.thevochat.com/gift/tag/3d.png"],
			"tagBanner": {
				"tagType": 4,
				"bg": "https://vochatapp.thevochat.com/gift/tag/banner/3d_en.png",
				"content": "The gift will trigger 3D animation",
				"jumpUrl": "",
				"extData": ""
			},
			"translationKey": "key_gift_449"
		}, {
			"giftid": 448,
			"gold": 1999,
			"name": "Ring",
			"image": "https://falla-res1.falla.live/785404-20211123_141827_1637648307446.png",
			"svga": "https://falla-res1.falla.live/785404-20210903_171147_1630660307276.mp4",
			"music": 1,
			"gifttype": 1,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 4,
			"cp": 2,
			"vip": 1,
			"vipIcon": "http://vochatapp.thevochat.com/nobility/1_s.png",
			"tags": ["https://vochatapp.thevochat.com/gift/tag/3d.png"],
			"tagBanner": {
				"tagType": 4,
				"bg": "https://vochatapp.thevochat.com/gift/tag/banner/3d_en.png",
				"content": "The gift will trigger 3D animation",
				"jumpUrl": "",
				"extData": ""
			},
			"translationKey": "key_gift_448"
		}, {
			"giftid": 445,
			"gold": 3333,
			"name": "Platform horses",
			"image": "https://falla-res1.falla.live/100936-20210828_155619_1630137379343.png",
			"svga": "https://falla-res1.falla.live/100936-20210828_155629_1630137389652.mp4",
			"music": 1,
			"gifttype": 2,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 4,
			"cp": 2,
			"vip": 1,
			"vipIcon": "http://vochatapp.thevochat.com/nobility/1_s.png",
			"tags": ["https://falla-res.falla.live/785404-20210929_162952_1632904192839.png", "https://vochatapp.thevochat.com/gift/tag/3d.png", "https://vochatapp.thevochat.com/gift/tag/global_banner.png"],
			"tagBanner": {
				"tagType": 5,
				"bg": "https://falla-res.falla.live/785404-20210929_162952_1632904192706.png",
				"content": "Send the gift to unlock",
				"jumpUrl": "vochat://medal/detail?medalKey=Carousel",
				"extData": "https://falla-res.falla.live/785404-20210929_142452_1632896692468.png"
			},
			"translationKey": "key_gift_445"
		}, {
			"giftid": 444,
			"gold": 8888,
			"name": "Spacecraft",
			"image": "https://falla-res1.falla.live/100936-20210828_155214_1630137134674.png",
			"svga": "https://falla-res1.falla.live/100936-20210828_155221_1630137141439.mp4",
			"music": 1,
			"gifttype": 2,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 4,
			"cp": 2,
			"vip": 2,
			"vipIcon": "http://vochatapp.thevochat.com/nobility/2_s.png",
			"tags": ["https://vochatapp.thevochat.com/gift/tag/3d.png", "https://vochatapp.thevochat.com/gift/tag/global_banner.png"],
			"tagBanner": {
				"tagType": 4,
				"bg": "https://vochatapp.thevochat.com/gift/tag/banner/3d_en.png",
				"content": "The gift will trigger 3D animation",
				"jumpUrl": "",
				"extData": ""
			},
			"translationKey": "key_gift_444"
		}, {
			"giftid": 443,
			"gold": 13000,
			"name": "Lipstick",
			"image": "https://falla-res1.falla.live/100936-20210828_154625_1630136785304.png",
			"svga": "https://falla-res1.falla.live/100936-20210828_154639_1630136799193.mp4",
			"music": 1,
			"gifttype": 2,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 4,
			"cp": 2,
			"vip": 3,
			"vipIcon": "http://vochatapp.thevochat.com/nobility/3_s.png",
			"tags": ["https://vochatapp.thevochat.com/gift/tag/3d.png", "https://vochatapp.thevochat.com/gift/tag/global_banner.png"],
			"tagBanner": {
				"tagType": 4,
				"bg": "https://vochatapp.thevochat.com/gift/tag/banner/3d_en.png",
				"content": "The gift will trigger 3D animation",
				"jumpUrl": "",
				"extData": ""
			},
			"translationKey": "key_gift_443"
		}, {
			"giftid": 442,
			"gold": 26666,
			"name": "Honeymoon Ferry",
			"image": "https://falla-res1.falla.live/785404-20210827_152105_1630048865406.png",
			"svga": "https://falla-res1.falla.live/785404-20210827_152108_1630048868125.mp4",
			"music": 1,
			"gifttype": 2,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 4,
			"cp": 2,
			"vip": 3,
			"vipIcon": "http://vochatapp.thevochat.com/nobility/3_s.png",
			"tags": ["https://falla-res.falla.live/785404-20210927_200410_1632744250852.png", "https://vochatapp.thevochat.com/gift/tag/3d.png", "https://vochatapp.thevochat.com/gift/tag/global_banner.png"],
			"tagBanner": {
				"tagType": 5,
				"bg": "https://falla-res.falla.live/785404-20210927_200410_1632744250987.png",
				"content": "Send the gift to unlock",
				"jumpUrl": "vochat://medal/detail?medalKey=Honeymoon_Ferry",
				"extData": "https://falla-res.falla.live/10000-20210827_172343_1630056223448.png"
			},
			"translationKey": "key_gift_442"
		}, {
			"giftid": 434,
			"gold": 26666,
			"name": "Ferris Wheel",
			"image": "https://falla-res1.falla.live/785404-20210816_145207_1629096727860.png",
			"svga": "https://falla-res1.falla.live/785404-20210816_145323_1629096803417.mp4",
			"music": 1,
			"gifttype": 2,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 4,
			"cp": 2,
			"vip": 4,
			"vipIcon": "http://vochatapp.thevochat.com/nobility/4_s.png",
			"tags": ["https://vochatapp.thevochat.com/gift/tag/3d.png", "https://vochatapp.thevochat.com/gift/tag/global_banner.png"],
			"tagBanner": {
				"tagType": 4,
				"bg": "https://vochatapp.thevochat.com/gift/tag/banner/3d_en.png",
				"content": "The gift will trigger 3D animation",
				"jumpUrl": "",
				"extData": ""
			},
			"translationKey": "key_gift_434"
		}, {
			"giftid": 433,
			"gold": 29999,
			"name": "Happy Party",
			"image": "https://falla-res1.falla.live/785404-20210816_144836_1629096516947.png",
			"svga": "https://falla-res1.falla.live/785404-20210817_103638_1629167798571.mp4",
			"music": 1,
			"gifttype": 2,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 4,
			"cp": 2,
			"vip": 4,
			"vipIcon": "http://vochatapp.thevochat.com/nobility/4_s.png",
			"tags": ["https://vochatapp.thevochat.com/gift/tag/3d.png", "https://vochatapp.thevochat.com/gift/tag/global_banner.png"],
			"tagBanner": {
				"tagType": 4,
				"bg": "https://vochatapp.thevochat.com/gift/tag/banner/3d_en.png",
				"content": "The gift will trigger 3D animation",
				"jumpUrl": "",
				"extData": ""
			},
			"translationKey": "key_gift_433"
		}, {
			"giftid": 428,
			"gold": 36666,
			"name": "Dream Castle",
			"image": "https://falla-res1.falla.live/785404-20210812_182629_1628763989614.png",
			"svga": "https://falla-res1.falla.live/785404-20210812_182747_1628764067143.mp4",
			"music": 1,
			"gifttype": 2,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 4,
			"cp": 2,
			"vip": 5,
			"vipIcon": "http://vochatapp.thevochat.com/nobility/5_s.png",
			"tags": ["https://falla-res.falla.live/785404-20210929_162243_1632903763345.png", "https://vochatapp.thevochat.com/gift/tag/3d.png", "https://vochatapp.thevochat.com/gift/tag/global_banner.png"],
			"tagBanner": {
				"tagType": 5,
				"bg": "https://falla-res.falla.live/785404-20210929_162245_1632903765505.png",
				"content": "Send the gift to unlock",
				"jumpUrl": "vochat://medal/detail?medalKey=Dream_Castle",
				"extData": "https://falla-res.falla.live/785404-20210929_143229_1632897149901.png"
			},
			"translationKey": "key_gift_428"
		}, {
			"giftid": 830,
			"gold": 1500,
			"name": "Venga mi hernanito",
			"image": "https://falla-res1.falla.live/119040-20220509_153905_1652081945948.png",
			"svga": "https://falla-res1.falla.live/119040-20220509_153908_1652081948103.svga",
			"music": 2,
			"gifttype": 1,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": [],
			"tagBanner": null,
			"translationKey": "72_bjdeminizz"
		}, {
			"giftid": 432,
			"gold": 39999,
			"name": "Honor Trophy",
			"image": "https://falla-res1.falla.live/785404-20210816_144458_1629096298577.png",
			"svga": "https://falla-res1.falla.live/785404-20210816_144619_1629096379464.mp4",
			"music": 1,
			"gifttype": 2,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 4,
			"cp": 2,
			"vip": 5,
			"vipIcon": "http://vochatapp.thevochat.com/nobility/5_s.png",
			"tags": ["https://falla-res.falla.live/785404-20210929_163305_1632904385209.png", "https://vochatapp.thevochat.com/gift/tag/3d.png", "https://vochatapp.thevochat.com/gift/tag/global_banner.png"],
			"tagBanner": {
				"tagType": 5,
				"bg": "https://falla-res.falla.live/785404-20210929_163306_1632904386328.png",
				"content": "Send the gift to unlock",
				"jumpUrl": "vochat://medal/detail?medalKey=Honor_Trophy",
				"extData": "https://falla-res.falla.live/785404-20210929_122720_1632889640193.png"
			},
			"translationKey": "key_gift_432"
		}, {
			"giftid": 456,
			"gold": 46666,
			"name": "Mech Warrior",
			"image": "https://falla-res1.falla.live/785404-20210906_151242_1630912362683.png",
			"svga": "https://falla-res1.falla.live/785404-20210906_151403_1630912443688.mp4",
			"music": 2,
			"gifttype": 2,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 4,
			"cp": 2,
			"vip": 5,
			"vipIcon": "http://vochatapp.thevochat.com/nobility/5_s.png",
			"tags": ["https://falla-res.falla.live/785404-20210929_161357_1632903237872.png", "https://vochatapp.thevochat.com/gift/tag/3d.png", "https://vochatapp.thevochat.com/gift/tag/global_banner.png"],
			"tagBanner": {
				"tagType": 5,
				"bg": "https://falla-res.falla.live/785404-20210929_161358_1632903238259.png",
				"content": "Send the gift to unlock",
				"jumpUrl": "vochat://medal/detail?medalKey=Mech_Warrior",
				"extData": "https://falla-res.falla.live/785404-20210929_150342_1632899022918.png"
			},
			"translationKey": "key_gift_456"
		}, {
			"giftid": 767,
			"gold": 66,
			"name": "Trompeta",
			"image": "https://falla-res1.falla.live/119040-20220330_175058_1648633858216.png",
			"svga": "https://falla-res1.falla.live/119040-20220422_145659_1650610619997.svga",
			"music": 2,
			"gifttype": 1,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": [],
			"tagBanner": null,
			"translationKey": "72_jgruemdvik"
		}, {
			"giftid": 315,
			"gold": 77,
			"name": "Two hearts",
			"image": "https://falla-res1.falla.live/119040-20210428_160951_1619597391448.png",
			"svga": "https://falla-res1.falla.live/119040-20210305_173523_1614936923966.svga",
			"music": 2,
			"gifttype": 1,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": [],
			"tagBanner": null,
			"translationKey": "key_gift_315"
		}, {
			"giftid": 118,
			"gold": 500,
			"name": "chocolate",
			"image": "https://falla-res1.falla.live/119040-20210428_161550_1619597750611.png",
			"svga": "https://falla-common.falla.live/119040-20200601_114341_1590983021142.svga",
			"music": 2,
			"gifttype": 1,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": [],
			"tagBanner": null,
			"translationKey": "key_gift_118"
		}, {
			"giftid": 296,
			"gold": 5000,
			"name": "Surprise",
			"image": "https://falla-res1.falla.live/119040-20210428_161049_1619597449260.png",
			"svga": "https://falla-res1.falla.live/119040-20210203_123936_1612327176165.svga",
			"music": 2,
			"gifttype": 2,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://vochatapp.thevochat.com/gift/tag/global_banner.png"],
			"tagBanner": {
				"tagType": 1,
				"bg": "https://vochatapp.thevochat.com/gift/tag/banner/global_banner_en.png",
				"content": "The gift will trigger a global broadcast",
				"jumpUrl": "",
				"extData": ""
			},
			"translationKey": "key_gift_296"
		}, {
			"giftid": 295,
			"gold": 400,
			"name": "Ballon of Love",
			"image": "https://falla-res1.falla.live/119040-20210428_161140_1619597500702.png",
			"svga": "https://falla-res1.falla.live/119040-20210203_123712_1612327032618.svga",
			"music": 2,
			"gifttype": 1,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": [],
			"tagBanner": null,
			"translationKey": "key_gift_295"
		}, {
			"giftid": 184,
			"gold": 1500,
			"name": "Romantic rose",
			"image": "https://falla-res1.falla.live/119040-20210428_161151_1619597511670.png",
			"svga": "https://falla-res1.falla.live/119040-20200824_200210_1598270530196.svga",
			"music": 2,
			"gifttype": 1,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": [],
			"tagBanner": null,
			"translationKey": "key_gift_184"
		}, {
			"giftid": 149,
			"gold": 5500,
			"name": "champagne",
			"image": "https://falla-res1.falla.live/119040-20210428_161203_1619597523334.png",
			"svga": "https://falla-res1.falla.live/119040-20200717_212123_1594992083226.svga",
			"music": 2,
			"gifttype": 2,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://vochatapp.thevochat.com/gift/tag/global_banner.png"],
			"tagBanner": {
				"tagType": 1,
				"bg": "https://vochatapp.thevochat.com/gift/tag/banner/global_banner_en.png",
				"content": "The gift will trigger a global broadcast",
				"jumpUrl": "",
				"extData": ""
			},
			"translationKey": "key_gift_149"
		}, {
			"giftid": 300,
			"gold": 200,
			"name": "Magic wand",
			"image": "https://falla-res1.falla.live/119040-20210428_181205_1619604725299.png",
			"svga": "https://falla-res1.falla.live/119040-20210208_121618_1612757778245.svga",
			"music": 2,
			"gifttype": 1,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": [],
			"tagBanner": null,
			"translationKey": "key_gift_300"
		}, {
			"giftid": 301,
			"gold": 2500,
			"name": "Candlelight dinner",
			"image": "https://falla-res1.falla.live/119040-20210428_161312_1619597592098.png",
			"svga": "https://falla-res1.falla.live/119040-20210208_121818_1612757898664.svga",
			"music": 2,
			"gifttype": 1,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://vochatapp.thevochat.com/gift/tag/global_banner.png"],
			"tagBanner": {
				"tagType": 1,
				"bg": "https://vochatapp.thevochat.com/gift/tag/banner/global_banner_en.png",
				"content": "The gift will trigger a global broadcast",
				"jumpUrl": "",
				"extData": ""
			},
			"translationKey": "key_gift_301"
		}, {
			"giftid": 180,
			"gold": 7000,
			"name": "Falcon",
			"image": "https://falla-res1.falla.live/119040-20210428_172948_1619602188783.png",
			"svga": "https://falla-res1.falla.live/119040-20200819_184942_1597834182603.svga",
			"music": 1,
			"gifttype": 2,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://vochatapp.thevochat.com/gift/tag/global_banner.png"],
			"tagBanner": {
				"tagType": 1,
				"bg": "https://vochatapp.thevochat.com/gift/tag/banner/global_banner_en.png",
				"content": "The gift will trigger a global broadcast",
				"jumpUrl": "",
				"extData": ""
			},
			"translationKey": "key_gift_180"
		}, {
			"giftid": 236,
			"gold": 50,
			"name": "Qatar flag",
			"image": "https://falla-res1.falla.live/575685-20220512_193002_1652355002470.png",
			"svga": "",
			"music": 2,
			"gifttype": 0,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 2,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": [],
			"tagBanner": null,
			"translationKey": "key_gift_236"
		}, {
			"giftid": 101,
			"gold": 300,
			"name": "cannon",
			"image": "https://falla-res1.falla.live/119040-20210428_161412_1619597652301.png",
			"svga": "https://falla-res1.falla.live/119040-20201125_185711_1606301831725.svga",
			"music": 2,
			"gifttype": 1,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": [],
			"tagBanner": null,
			"translationKey": "key_gift_101"
		}, {
			"giftid": 259,
			"gold": 50,
			"name": "Bahrain Flag",
			"image": "https://falla-res1.falla.live/575685-20220512_193035_1652355035071.png",
			"svga": "",
			"music": 2,
			"gifttype": 0,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 2,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": [],
			"tagBanner": null,
			"translationKey": "key_gift_259"
		}, {
			"giftid": 401,
			"gold": 200,
			"name": "Honey",
			"image": "https://falla-res1.falla.live/119040-20210805_190753_1628161673668.png",
			"svga": "https://falla-res1.falla.live/119040-20210715_104929_1626317369167.svga",
			"music": 2,
			"gifttype": 1,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": [],
			"tagBanner": null,
			"translationKey": "key_gift_401"
		}, {
			"giftid": 280,
			"gold": 999,
			"name": "Camel",
			"image": "https://falla-res1.falla.live/119040-20210428_161614_1619597774777.png",
			"svga": "https://falla-res1.falla.live/119040-20210109_191542_1610190942502.svga",
			"music": 2,
			"gifttype": 1,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": [],
			"tagBanner": null,
			"translationKey": "key_gift_280"
		}, {
			"giftid": 289,
			"gold": 1200,
			"name": "Shinning star",
			"image": "https://falla-res1.falla.live/119040-20210428_161624_1619597784399.png",
			"svga": "https://falla-res1.falla.live/119040-20210120_104429_1611110669126.svga",
			"music": 2,
			"gifttype": 1,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": [],
			"tagBanner": null,
			"translationKey": "key_gift_289"
		}, {
			"giftid": 18,
			"gold": 1888,
			"name": "diamond",
			"image": "https://falla-res1.falla.live/119040-20210428_161636_1619597796893.png",
			"svga": "https://falla-common.falla.live/119040-20200315_222323_1584282203259.svga",
			"music": 2,
			"gifttype": 1,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": [],
			"tagBanner": null,
			"translationKey": "key_gift_18"
		}, {
			"giftid": 126,
			"gold": 3500,
			"name": "watch",
			"image": "https://falla-res1.falla.live/119040-20210428_161650_1619597810205.png",
			"svga": "https://falla-res1.falla.live/119040-20200613_213027_1592055027621.svga",
			"music": 2,
			"gifttype": 2,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://vochatapp.thevochat.com/gift/tag/global_banner.png"],
			"tagBanner": {
				"tagType": 1,
				"bg": "https://vochatapp.thevochat.com/gift/tag/banner/global_banner_en.png",
				"content": "The gift will trigger a global broadcast",
				"jumpUrl": "",
				"extData": ""
			},
			"translationKey": "key_gift_126"
		}, {
			"giftid": 46,
			"gold": 7,
			"name": "Star",
			"image": "https://falla-res1.falla.live/119040-20210305_173359_1614936839259.png",
			"svga": "",
			"music": 2,
			"gifttype": 0,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": [],
			"tagBanner": null,
			"translationKey": "key_gift_46"
		}, {
			"giftid": 249,
			"gold": 77,
			"name": "Poppers",
			"image": "https://falla-res1.falla.live/119040-20210428_161700_1619597820553.png",
			"svga": "https://falla-res1.falla.live/119040-20201127_123639_1606451799615.svga",
			"music": 2,
			"gifttype": 1,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": [],
			"tagBanner": null,
			"translationKey": "key_gift_249"
		}, {
			"giftid": 116,
			"gold": 150,
			"name": "ice-cream",
			"image": "https://falla-res1.falla.live/119040-20210428_161715_1619597835191.png",
			"svga": "https://falla-common.falla.live/119040-20200601_113855_1590982735667.svga",
			"music": 2,
			"gifttype": 1,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": [],
			"tagBanner": null,
			"translationKey": "key_gift_116"
		}, {
			"giftid": 403,
			"gold": 150,
			"name": "Tea",
			"image": "https://falla-res1.falla.live/119040-20210805_103216_1628130736251.png",
			"svga": "https://falla-res1.falla.live/119040-20210715_105222_1626317542404.svga",
			"music": 2,
			"gifttype": 1,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": [],
			"tagBanner": null,
			"translationKey": "key_gift_403"
		}, {
			"giftid": 372,
			"gold": 500,
			"name": "Swan",
			"image": "https://falla-res1.falla.live/119040-20210609_162426_1623227066931.png",
			"svga": "https://falla-res1.falla.live/119040-20210609_162427_1623227067112.svga",
			"music": 2,
			"gifttype": 1,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": [],
			"tagBanner": null,
			"translationKey": "key_gift_372"
		}, {
			"giftid": 127,
			"gold": 800,
			"name": "Swan",
			"image": "https://falla-res1.falla.live/119040-20200613_205051_1592052651763.png",
			"svga": "https://falla-res1.falla.live/119040-20200613_205058_1592052658886.svga",
			"music": 2,
			"gifttype": 1,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": [],
			"tagBanner": null,
			"translationKey": "key_gift_127"
		}, {
			"giftid": 78,
			"gold": 999,
			"name": "meteor",
			"image": "https://falla-common.falla.live/119040-20200526_112942_1590463782874.png",
			"svga": "https://falla-common.falla.live/119040-20200315_215003_1584280203036.svga",
			"music": 2,
			"gifttype": 1,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": [],
			"tagBanner": null,
			"translationKey": "key_gift_78"
		}, {
			"giftid": 252,
			"gold": 3500,
			"name": "Holiday",
			"image": "https://falla-res1.falla.live/119040-20201130_211014_1606741814641.png",
			"svga": "https://falla-res1.falla.live/119040-20201130_211020_1606741820113.svga",
			"music": 2,
			"gifttype": 2,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://vochatapp.thevochat.com/gift/tag/global_banner.png"],
			"tagBanner": {
				"tagType": 1,
				"bg": "https://vochatapp.thevochat.com/gift/tag/banner/global_banner_en.png",
				"content": "The gift will trigger a global broadcast",
				"jumpUrl": "",
				"extData": ""
			},
			"translationKey": "key_gift_252"
		}, {
			"giftid": 349,
			"gold": 8888,
			"name": "Ferris wheel",
			"image": "https://falla-res1.falla.live/119040-20210506_142315_1620282195160.png",
			"svga": "https://falla-res1.falla.live/119040-20210506_142318_1620282198934.svga",
			"music": 2,
			"gifttype": 2,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://vochatapp.thevochat.com/gift/tag/global_banner.png"],
			"tagBanner": {
				"tagType": 1,
				"bg": "https://vochatapp.thevochat.com/gift/tag/banner/global_banner_en.png",
				"content": "The gift will trigger a global broadcast",
				"jumpUrl": "",
				"extData": ""
			},
			"translationKey": "key_gift_349"
		}, {
			"giftid": 174,
			"gold": 50,
			"name": "Indian flag",
			"image": "https://falla-res1.falla.live/575685-20220512_193103_1652355063059.png",
			"svga": "",
			"music": 2,
			"gifttype": 0,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 2,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": [],
			"tagBanner": null,
			"translationKey": "key_gift_174"
		}, {
			"giftid": 176,
			"gold": 50,
			"name": "Pakistan flag",
			"image": "https://falla-res1.falla.live/575685-20220512_193135_1652355095606.png",
			"svga": "",
			"music": 2,
			"gifttype": 0,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 2,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": [],
			"tagBanner": null,
			"translationKey": "key_gift_176"
		}, {
			"giftid": 235,
			"gold": 50,
			"name": "UAE flag",
			"image": "https://falla-res1.falla.live/575685-20220512_193317_1652355197567.png",
			"svga": "",
			"music": 2,
			"gifttype": 0,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 2,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": [],
			"tagBanner": null,
			"translationKey": "key_gift_235"
		}, {
			"giftid": 64,
			"gold": 88,
			"name": "Music rain",
			"image": "https://falla-common.falla.live/119040-20200315_221921_1584281961815.png",
			"svga": "https://falla-common.falla.live/119040-20200315_221926_1584281966590.svga",
			"music": 1,
			"gifttype": 1,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": [],
			"tagBanner": null,
			"translationKey": "key_gift_64"
		}, {
			"giftid": 272,
			"gold": 100,
			"name": "Blue rose",
			"image": "https://falla-res1.falla.live/119040-20210113_142556_1610519156902.png",
			"svga": "https://falla-res1.falla.live/119040-20210107_155219_1610005939239.svga",
			"music": 2,
			"gifttype": 1,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": [],
			"tagBanner": null,
			"translationKey": "key_gift_272"
		}, {
			"giftid": 81,
			"gold": 300,
			"name": "micphone",
			"image": "https://falla-res1.falla.live/119040-20210428_161801_1619597881686.png",
			"svga": "https://falla-res1.falla.live/119040-20210410_160935_1618042175309.svga",
			"music": 2,
			"gifttype": 1,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": [],
			"tagBanner": null,
			"translationKey": "key_gift_81"
		}, {
			"giftid": 205,
			"gold": 799,
			"name": "Crystal shoes",
			"image": "https://falla-res1.falla.live/119040-20210428_161812_1619597892960.png",
			"svga": "https://falla-res1.falla.live/119040-20200930_155814_1601452694899.svga",
			"music": 2,
			"gifttype": 1,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": [],
			"tagBanner": null,
			"translationKey": "key_gift_205"
		}, {
			"giftid": 204,
			"gold": 888,
			"name": "Wishing bottle",
			"image": "https://falla-res1.falla.live/119040-20210428_161828_1619597908009.png",
			"svga": "https://falla-res1.falla.live/119040-20200930_154901_1601452141724.svga",
			"music": 2,
			"gifttype": 1,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": [],
			"tagBanner": null,
			"translationKey": "key_gift_204"
		}, {
			"giftid": 251,
			"gold": 2200,
			"name": "Handbag",
			"image": "https://falla-res1.falla.live/119040-20210428_161848_1619597928989.png",
			"svga": "https://falla-res1.falla.live/119040-20201130_210835_1606741715019.svga",
			"music": 2,
			"gifttype": 1,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://vochatapp.thevochat.com/gift/tag/global_banner.png"],
			"tagBanner": {
				"tagType": 1,
				"bg": "https://vochatapp.thevochat.com/gift/tag/banner/global_banner_en.png",
				"content": "The gift will trigger a global broadcast",
				"jumpUrl": "",
				"extData": ""
			},
			"translationKey": "key_gift_251"
		}, {
			"giftid": 103,
			"gold": 2500,
			"name": "magic lamp",
			"image": "https://falla-res1.falla.live/119040-20210428_161903_1619597943633.png",
			"svga": "https://falla-common.falla.live/119040-20200421_204743_1587473263967.svga",
			"music": 2,
			"gifttype": 1,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://vochatapp.thevochat.com/gift/tag/global_banner.png"],
			"tagBanner": {
				"tagType": 1,
				"bg": "https://vochatapp.thevochat.com/gift/tag/banner/global_banner_en.png",
				"content": "The gift will trigger a global broadcast",
				"jumpUrl": "",
				"extData": ""
			},
			"translationKey": "key_gift_103"
		}, {
			"giftid": 171,
			"gold": 66,
			"name": "tomato",
			"image": "https://falla-res1.falla.live/119040-20210428_161913_1619597953873.png",
			"svga": "https://falla-res1.falla.live/119040-20200808_190947_1596884987840.svga",
			"music": 2,
			"gifttype": 1,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": [],
			"tagBanner": null,
			"translationKey": "key_gift_171"
		}, {
			"giftid": 197,
			"gold": 50,
			"name": "KSA Flag",
			"image": "https://falla-res1.falla.live/575685-20220512_193344_1652355224456.png",
			"svga": "",
			"music": 2,
			"gifttype": 0,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 2,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": [],
			"tagBanner": null,
			"translationKey": "key_gift_197"
		}, {
			"giftid": 144,
			"gold": 4999,
			"name": "Kingdom Tower",
			"image": "https://falla-res1.falla.live/119040-20210428_150700_1619593620893.png",
			"svga": "https://falla-res1.falla.live/119040-20200714_112759_1594697279257.svga",
			"music": 1,
			"gifttype": 2,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 2,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://vochatapp.thevochat.com/gift/tag/global_banner.png"],
			"tagBanner": {
				"tagType": 1,
				"bg": "https://vochatapp.thevochat.com/gift/tag/banner/global_banner_en.png",
				"content": "The gift will trigger a global broadcast",
				"jumpUrl": "",
				"extData": ""
			},
			"translationKey": "key_gift_144"
		}, {
			"giftid": 140,
			"gold": 4999,
			"name": "Burj Al Arab",
			"image": "https://falla-res1.falla.live/119040-20210428_150724_1619593644428.png",
			"svga": "https://falla-res1.falla.live/119040-20200711_144714_1594450034338.svga",
			"music": 1,
			"gifttype": 2,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 2,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://vochatapp.thevochat.com/gift/tag/global_banner.png"],
			"tagBanner": {
				"tagType": 1,
				"bg": "https://vochatapp.thevochat.com/gift/tag/banner/global_banner_en.png",
				"content": "The gift will trigger a global broadcast",
				"jumpUrl": "",
				"extData": ""
			},
			"translationKey": "key_gift_140"
		}, {
			"giftid": 138,
			"gold": 50,
			"name": "Iraq flag",
			"image": "https://falla-res1.falla.live/575685-20220512_193412_1652355252404.png",
			"svga": "",
			"music": 2,
			"gifttype": 0,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 2,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": [],
			"tagBanner": null,
			"translationKey": "key_gift_138"
		}, {
			"giftid": 237,
			"gold": 50,
			"name": "Kuwait flag",
			"image": "https://falla-res1.falla.live/575685-20220512_203526_1652358926721.png",
			"svga": "",
			"music": 2,
			"gifttype": 0,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 2,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": [],
			"tagBanner": null,
			"translationKey": "key_gift_237"
		}, {
			"giftid": 239,
			"gold": 50,
			"name": "Bangladesh",
			"image": "https://falla-res1.falla.live/575685-20220512_193934_1652355574018.png",
			"svga": "",
			"music": 2,
			"gifttype": 0,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 2,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": [],
			"tagBanner": null,
			"translationKey": "key_gift_239"
		}, {
			"giftid": 648,
			"gold": 4999,
			"name": "Estatua de Cristo de Río",
			"image": "https://falla-res1.falla.live/119040-20220121_155040_1642751440089.png",
			"svga": "https://falla-res1.falla.live/119040-20220121_155041_1642751441572.svga",
			"music": 2,
			"gifttype": 2,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 2,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://vochatapp.thevochat.com/gift/tag/global_banner.png"],
			"tagBanner": {
				"tagType": 1,
				"bg": "https://vochatapp.thevochat.com/gift/tag/banner/global_banner_en.png",
				"content": "The gift will trigger a global broadcast",
				"jumpUrl": "",
				"extData": ""
			},
			"translationKey": "72_slhbeaippk"
		}, {
			"giftid": 147,
			"gold": 4999,
			"name": "Kuwait Tower",
			"image": "https://falla-res1.falla.live/119040-20210428_150750_1619593670334.png",
			"svga": "https://falla-res1.falla.live/119040-20200717_211717_1594991837686.svga",
			"music": 1,
			"gifttype": 2,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 2,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://vochatapp.thevochat.com/gift/tag/global_banner.png"],
			"tagBanner": {
				"tagType": 1,
				"bg": "https://vochatapp.thevochat.com/gift/tag/banner/global_banner_en.png",
				"content": "The gift will trigger a global broadcast",
				"jumpUrl": "",
				"extData": ""
			},
			"translationKey": "key_gift_147"
		}, {
			"giftid": 230,
			"gold": 50,
			"name": "Oman Flag",
			"image": "https://falla-res1.falla.live/575685-20220512_203548_1652358948500.png",
			"svga": "",
			"music": 2,
			"gifttype": 0,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 2,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": [],
			"tagBanner": null,
			"translationKey": "key_gift_230"
		}, {
			"giftid": 186,
			"gold": 4999,
			"name": "Al Alam Palace",
			"image": "https://falla-res1.falla.live/119040-20210428_150810_1619593690647.png",
			"svga": "https://falla-res1.falla.live/119040-20200902_121313_1599019993618.svga",
			"music": 1,
			"gifttype": 2,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 2,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://vochatapp.thevochat.com/gift/tag/global_banner.png"],
			"tagBanner": {
				"tagType": 1,
				"bg": "https://vochatapp.thevochat.com/gift/tag/banner/global_banner_en.png",
				"content": "The gift will trigger a global broadcast",
				"jumpUrl": "",
				"extData": ""
			},
			"translationKey": "key_gift_186"
		}, {
			"giftid": 210,
			"gold": 4999,
			"name": "Aspire tower",
			"image": "https://falla-res1.falla.live/119040-20210428_153453_1619595293859.png",
			"svga": "https://falla-res1.falla.live/119040-20201014_112027_1602645627721.svga",
			"music": 1,
			"gifttype": 2,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 2,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://vochatapp.thevochat.com/gift/tag/global_banner.png"],
			"tagBanner": {
				"tagType": 1,
				"bg": "https://vochatapp.thevochat.com/gift/tag/banner/global_banner_en.png",
				"content": "The gift will trigger a global broadcast",
				"jumpUrl": "",
				"extData": ""
			},
			"translationKey": "key_gift_210"
		}, {
			"giftid": 240,
			"gold": 50,
			"name": "Syria flag",
			"image": "https://falla-res1.falla.live/575685-20220512_194039_1652355639598.png",
			"svga": "",
			"music": 2,
			"gifttype": 0,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 2,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://falla-res.falla.live/575685-20220105_175141_1641376301312.png"],
			"tagBanner": {
				"tagType": 7,
				"bg": "https://falla-res1.falla.live/awss3_575685_1655441506703285571_4095954802.png",
				"content": ".",
				"jumpUrl": "https://web.falla.live/falla-web/micro-main/index.html#/act-father-day/invitation",
				"extData": ""
			},
			"translationKey": "key_gift_240"
		}, {
			"giftid": 588,
			"gold": 4999,
			"name": "Sagrada Familia",
			"image": "https://falla-res1.falla.live/119040-20211213_175901_1639389541731.png",
			"svga": "https://falla-res1.falla.live/119040-20211213_180110_1639389670732.svga",
			"music": 2,
			"gifttype": 2,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 2,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://vochatapp.thevochat.com/gift/tag/global_banner.png"],
			"tagBanner": {
				"tagType": 1,
				"bg": "https://vochatapp.thevochat.com/gift/tag/banner/global_banner_en.png",
				"content": "The gift will trigger a global broadcast",
				"jumpUrl": "",
				"extData": ""
			},
			"translationKey": "72_bvuznekgiy"
		}, {
			"giftid": 195,
			"gold": 4999,
			"name": "Bahrain World Trade Center",
			"image": "https://falla-res1.falla.live/119040-20210428_153804_1619595484354.png",
			"svga": "https://falla-res1.falla.live/119040-20200911_172302_1599816182582.svga",
			"music": 1,
			"gifttype": 2,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 2,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://vochatapp.thevochat.com/gift/tag/global_banner.png"],
			"tagBanner": {
				"tagType": 1,
				"bg": "https://vochatapp.thevochat.com/gift/tag/banner/global_banner_en.png",
				"content": "The gift will trigger a global broadcast",
				"jumpUrl": "",
				"extData": ""
			},
			"translationKey": "key_gift_195"
		}, {
			"giftid": 781,
			"gold": 50,
			"name": "Bandera Perú",
			"image": "https://falla-res1.falla.live/575685-20220512_203639_1652358999642.png",
			"svga": "",
			"music": 2,
			"gifttype": 0,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 2,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": [],
			"tagBanner": null,
			"translationKey": "72_veqyicpmga"
		}, {
			"giftid": 114,
			"gold": 50,
			"name": "YEM Flag",
			"image": "https://falla-res1.falla.live/575685-20220512_194206_1652355726115.png",
			"svga": "",
			"music": 2,
			"gifttype": 0,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 2,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": [],
			"tagBanner": null,
			"translationKey": "key_gift_114"
		}, {
			"giftid": 673,
			"gold": 50,
			"name": "Brazil flag",
			"image": "https://falla-res1.falla.live/575685-20220512_194229_1652355749826.png",
			"svga": "",
			"music": 2,
			"gifttype": 0,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 2,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": [],
			"tagBanner": null,
			"translationKey": "72_owsrstrtpj"
		}, {
			"giftid": 754,
			"gold": 50,
			"name": "Afghan flag",
			"image": "https://falla-res1.falla.live/575685-20220512_194258_1652355778570.png",
			"svga": "",
			"music": 2,
			"gifttype": 0,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 2,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": [],
			"tagBanner": null,
			"translationKey": "72_hdgdeguzmp"
		}, {
			"giftid": 755,
			"gold": 50,
			"name": "Philippine flag",
			"image": "https://falla-res1.falla.live/575685-20220512_194320_1652355800799.png",
			"svga": "",
			"music": 2,
			"gifttype": 0,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 2,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": [],
			"tagBanner": null,
			"translationKey": "72_teinjztbgs"
		}, {
			"giftid": 785,
			"gold": 4999,
			"name": "Glaciar Grey",
			"image": "https://falla-res1.falla.live/119040-20220406_155714_1649231834524.png",
			"svga": "https://falla-res1.falla.live/119040-20220406_155716_1649231836915.svga",
			"music": 2,
			"gifttype": 2,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 2,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://vochatapp.thevochat.com/gift/tag/global_banner.png"],
			"tagBanner": {
				"tagType": 1,
				"bg": "https://vochatapp.thevochat.com/gift/tag/banner/global_banner_en.png",
				"content": "The gift will trigger a global broadcast",
				"jumpUrl": "",
				"extData": ""
			},
			"translationKey": "72_rcxwhijani"
		}, {
			"giftid": 159,
			"gold": 4999,
			"name": "Al-Saleh",
			"image": "https://falla-res1.falla.live/119040-20210428_162738_1619598458811.png",
			"svga": "https://falla-res1.falla.live/119040-20200725_190620_1595675180503.svga",
			"music": 1,
			"gifttype": 2,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 2,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://vochatapp.thevochat.com/gift/tag/global_banner.png"],
			"tagBanner": {
				"tagType": 1,
				"bg": "https://vochatapp.thevochat.com/gift/tag/banner/global_banner_en.png",
				"content": "The gift will trigger a global broadcast",
				"jumpUrl": "",
				"extData": ""
			},
			"translationKey": "key_gift_159"
		}, {
			"giftid": 701,
			"gold": 4999,
			"name": "Machu Picchu",
			"image": "https://falla-res1.falla.live/119040-20220224_181715_1645697835636.png",
			"svga": "https://falla-res1.falla.live/119040-20220224_181747_1645697867543.svga",
			"music": 2,
			"gifttype": 2,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 2,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://vochatapp.thevochat.com/gift/tag/global_banner.png"],
			"tagBanner": {
				"tagType": 1,
				"bg": "https://vochatapp.thevochat.com/gift/tag/banner/global_banner_en.png",
				"content": "The gift will trigger a global broadcast",
				"jumpUrl": "",
				"extData": ""
			},
			"translationKey": "72_pwljquxirx"
		}, {
			"giftid": 29,
			"gold": 50,
			"name": "kiss",
			"image": "https://falla-res1.falla.live/119040-20210809_152158_1628493718252.png",
			"svga": "https://falla-res1.falla.live/119040-20210809_152159_1628493719393.svga",
			"music": 2,
			"gifttype": 1,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://falla-res.falla.live/785404-20210929_161955_1632903595654.png"],
			"tagBanner": {
				"tagType": 5,
				"bg": "https://falla-res.falla.live/785404-20210929_161958_1632903598080.png",
				"content": "Send the gift to unlock",
				"jumpUrl": "vochat://medal/detail?medalKey=Kiss",
				"extData": "https://falla-res.falla.live/785404-20210929_144816_1632898096433.png"
			},
			"translationKey": "key_gift_29"
		}, {
			"giftid": 157,
			"gold": 50,
			"name": "Morocco flag",
			"image": "https://falla-res1.falla.live/575685-20220512_203708_1652359028359.png",
			"svga": "",
			"music": 2,
			"gifttype": 0,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 2,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": [],
			"tagBanner": null,
			"translationKey": "key_gift_157"
		}, {
			"giftid": 288,
			"gold": 2000,
			"name": "Cupid",
			"image": "https://falla-res1.falla.live/119040-20210428_161439_1619597679581.png",
			"svga": "https://falla-res1.falla.live/119040-20210120_104212_1611110532196.svga",
			"music": 2,
			"gifttype": 1,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://falla-res.falla.live/785404-20210929_162739_1632904059642.png", "https://vochatapp.thevochat.com/gift/tag/global_banner.png"],
			"tagBanner": {
				"tagType": 5,
				"bg": "https://falla-res.falla.live/785404-20210929_162742_1632904062131.png",
				"content": "Send the gift to unlock",
				"jumpUrl": "vochat://medal/detail?medalKey=Cupid",
				"extData": "https://falla-res.falla.live/785404-20210929_143024_1632897024069.png"
			},
			"translationKey": "key_gift_288"
		}, {
			"giftid": 802,
			"gold": 3000,
			"name": "Music party",
			"image": "https://falla-res1.falla.live/785404-20220420_101057_1650420657350.png",
			"svga": "https://falla-res1.falla.live/785404-20220422_104526_1650595526620.mp4",
			"music": 2,
			"gifttype": 2,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://vochatapp.thevochat.com/gift/tag/3d.png", "https://vochatapp.thevochat.com/gift/tag/global_banner.png"],
			"tagBanner": {
				"tagType": 4,
				"bg": "https://vochatapp.thevochat.com/gift/tag/banner/3d_en.png",
				"content": "The gift will trigger 3D animation",
				"jumpUrl": "",
				"extData": ""
			},
			"translationKey": "72_fwcxravviy"
		}, {
			"giftid": 834,
			"gold": 3499,
			"name": "Fireworks",
			"image": "https://falla-res1.falla.live/575685-20220512_175256_1652349176960.png",
			"svga": "https://falla-res1.falla.live/575685-20220517_003034_1652718634242.svga",
			"music": 2,
			"gifttype": 2,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://vochatapp.thevochat.com/gift/tag/global_banner.png"],
			"tagBanner": {
				"tagType": 1,
				"bg": "https://vochatapp.thevochat.com/gift/tag/banner/global_banner_en.png",
				"content": "The gift will trigger a global broadcast",
				"jumpUrl": "",
				"extData": ""
			},
			"translationKey": "key_gift_16"
		}, {
			"giftid": 143,
			"gold": 4999,
			"name": "Hassan II",
			"image": "https://falla-res1.falla.live/119040-20210428_153830_1619595510164.png",
			"svga": "https://falla-res1.falla.live/119040-20200731_101358_1596161638980.svga",
			"music": 1,
			"gifttype": 2,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 2,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://vochatapp.thevochat.com/gift/tag/global_banner.png"],
			"tagBanner": {
				"tagType": 1,
				"bg": "https://vochatapp.thevochat.com/gift/tag/banner/global_banner_en.png",
				"content": "The gift will trigger a global broadcast",
				"jumpUrl": "",
				"extData": ""
			},
			"translationKey": "key_gift_143"
		}, {
			"giftid": 807,
			"gold": 9,
			"name": "Papatya",
			"image": "https://falla-res1.falla.live/575685-20220428_033323_1651088003779.png",
			"svga": "",
			"music": 2,
			"gifttype": 0,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": [],
			"tagBanner": null,
			"translationKey": "72_rdhzkpwzsj"
		}, {
			"giftid": 809,
			"gold": 37,
			"name": "Blue Roses",
			"image": "https://falla-res1.falla.live/575685-20220428_033524_1651088124664.png",
			"svga": "",
			"music": 2,
			"gifttype": 0,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": [],
			"tagBanner": null,
			"translationKey": "72_qtgauccnbf"
		}, {
			"giftid": 79,
			"gold": 37,
			"name": "pink roses",
			"image": "https://falla-res1.falla.live/119040-20210428_161525_1619597725929.png",
			"svga": "",
			"music": 2,
			"gifttype": 0,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": [],
			"tagBanner": null,
			"translationKey": "key_gift_79"
		}, {
			"giftid": 835,
			"gold": 3000,
			"name": "Love of Daisy",
			"image": "https://falla-res1.falla.live/575685-20220512_180645_1652350005511.png",
			"svga": "https://falla-res1.falla.live/575685-20220517_012445_1652721885690.svga",
			"music": 2,
			"gifttype": 2,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://vochatapp.thevochat.com/gift/tag/global_banner.png"],
			"tagBanner": {
				"tagType": 1,
				"bg": "https://vochatapp.thevochat.com/gift/tag/banner/global_banner_en.png",
				"content": "The gift will trigger a global broadcast",
				"jumpUrl": "",
				"extData": ""
			},
			"translationKey": "72_nauczlcfny"
		}, {
			"giftid": 241,
			"gold": 4999,
			"name": "Minar-e-Pakistan",
			"image": "https://falla-res1.falla.live/119040-20210428_162822_1619598502830.png",
			"svga": "https://falla-res1.falla.live/119040-20201117_210637_1605618397264.svga",
			"music": 1,
			"gifttype": 2,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 2,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://vochatapp.thevochat.com/gift/tag/global_banner.png"],
			"tagBanner": {
				"tagType": 1,
				"bg": "https://vochatapp.thevochat.com/gift/tag/banner/global_banner_en.png",
				"content": "The gift will trigger a global broadcast",
				"jumpUrl": "",
				"extData": ""
			},
			"translationKey": "key_gift_241"
		}, {
			"giftid": 12,
			"gold": 9,
			"name": "Golden rose",
			"image": "https://falla-res1.falla.live/119040-20210428_160921_1619597361047.png",
			"svga": "",
			"music": 2,
			"gifttype": 0,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": [],
			"tagBanner": null,
			"translationKey": "key_gift_12"
		}, {
			"giftid": 320,
			"gold": 9,
			"name": "Rose",
			"image": "https://falla-res1.falla.live/119040-20210428_160711_1619597231740.png",
			"svga": "",
			"music": 2,
			"gifttype": 0,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": [],
			"tagBanner": null,
			"translationKey": "key_gift_320"
		}, {
			"giftid": 558,
			"gold": 10,
			"name": "Blue heart",
			"image": "https://falla-res1.falla.live/785404-20211125_110820_1637809700542.png",
			"svga": "",
			"music": 2,
			"gifttype": 0,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": [],
			"tagBanner": null,
			"translationKey": "72_bghyylbelz"
		}, {
			"giftid": 485,
			"gold": 10,
			"name": "Yellow heart",
			"image": "https://falla-res1.falla.live/785404-20211125_105643_1637809003130.png",
			"svga": "",
			"music": 2,
			"gifttype": 0,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": [],
			"tagBanner": null,
			"translationKey": "key_gift_485"
		}, {
			"giftid": 156,
			"gold": 4999,
			"name": "Baghdad Tower",
			"image": "https://falla-res1.falla.live/119040-20210428_162753_1619598473015.png",
			"svga": "https://falla-res1.falla.live/119040-20200725_182056_1595672456540.svga",
			"music": 1,
			"gifttype": 2,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 2,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://vochatapp.thevochat.com/gift/tag/global_banner.png"],
			"tagBanner": {
				"tagType": 1,
				"bg": "https://vochatapp.thevochat.com/gift/tag/banner/global_banner_en.png",
				"content": "The gift will trigger a global broadcast",
				"jumpUrl": "",
				"extData": ""
			},
			"translationKey": "key_gift_156"
		}, {
			"giftid": 145,
			"gold": 50,
			"name": "Egypt flag",
			"image": "https://falla-res1.falla.live/575685-20220512_194406_1652355846905.png",
			"svga": "",
			"music": 2,
			"gifttype": 0,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 2,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": [],
			"tagBanner": null,
			"translationKey": "key_gift_145"
		}, {
			"giftid": 486,
			"gold": 100,
			"name": "Pink bear",
			"image": "https://falla-res1.falla.live/785404-20211124_145603_1637736963946.png",
			"svga": "https://falla-res1.falla.live/785404-20211124_145606_1637736966592.svga",
			"music": 2,
			"gifttype": 1,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://falla-res.falla.live/785404-20220505_192039_1651749639461.png"],
			"tagBanner": {
				"tagType": 5,
				"bg": "https://falla-res.falla.live/785404-20220505_192043_1651749643131.png",
				"content": "Send the gift to unlock",
				"jumpUrl": "vochat://medal/detail?medalKey=pinkbear",
				"extData": "https://falla-res.falla.live/785404-20220429_161836_1651220316472.png"
			},
			"translationKey": "key_gift_486"
		}, {
			"giftid": 285,
			"gold": 1000,
			"name": "Perfume",
			"image": "https://falla-res1.falla.live/119040-20210428_161004_1619597404259.png",
			"svga": "https://falla-res1.falla.live/119040-20210118_112042_1610940042360.svga",
			"music": 2,
			"gifttype": 1,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": [],
			"tagBanner": null,
			"translationKey": "key_gift_285"
		}, {
			"giftid": 676,
			"gold": 3333,
			"name": "Love wings",
			"image": "https://falla-res1.falla.live/785404-20220211_185021_1644576621053.png",
			"svga": "https://falla-res1.falla.live/785404-20220301_150140_1646118100697.svga",
			"music": 2,
			"gifttype": 2,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://vochatapp.thevochat.com/gift/tag/global_banner.png"],
			"tagBanner": {
				"tagType": 1,
				"bg": "https://vochatapp.thevochat.com/gift/tag/banner/global_banner_en.png",
				"content": "The gift will trigger a global broadcast",
				"jumpUrl": "",
				"extData": ""
			},
			"translationKey": "72_krxvdzmcir"
		}, {
			"giftid": 254,
			"gold": 4999,
			"name": "Pyramid",
			"image": "https://falla-res1.falla.live/119040-20210428_153953_1619595593617.png",
			"svga": "https://falla-res1.falla.live/119040-20201204_191841_1607080721109.svga",
			"music": 1,
			"gifttype": 2,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 2,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://vochatapp.thevochat.com/gift/tag/global_banner.png"],
			"tagBanner": {
				"tagType": 1,
				"bg": "https://vochatapp.thevochat.com/gift/tag/banner/global_banner_en.png",
				"content": "The gift will trigger a global broadcast",
				"jumpUrl": "",
				"extData": ""
			},
			"translationKey": "key_gift_254"
		}, {
			"giftid": 292,
			"gold": 5000,
			"name": "Dancing",
			"image": "https://falla-res1.falla.live/119040-20210428_171550_1619601350494.png",
			"svga": "https://falla-res1.falla.live/119040-20210123_103526_1611369326779.svga",
			"music": 1,
			"gifttype": 2,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://vochatapp.thevochat.com/gift/tag/global_banner.png"],
			"tagBanner": {
				"tagType": 1,
				"bg": "https://vochatapp.thevochat.com/gift/tag/banner/global_banner_en.png",
				"content": "The gift will trigger a global broadcast",
				"jumpUrl": "",
				"extData": ""
			},
			"translationKey": "key_gift_292"
		}, {
			"giftid": 134,
			"gold": 50,
			"name": "Algeria flag",
			"image": "https://falla-res1.falla.live/575685-20220512_194435_1652355875674.png",
			"svga": "",
			"music": 2,
			"gifttype": 0,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 2,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": [],
			"tagBanner": null,
			"translationKey": "key_gift_134"
		}, {
			"giftid": 56,
			"gold": 2200,
			"name": "Suit",
			"image": "https://falla-res1.falla.live/119040-20210428_171430_1619601270925.png",
			"svga": "https://falla-common.falla.live/119040-20200315_215153_1584280313861.svga",
			"music": 2,
			"gifttype": 1,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://vochatapp.thevochat.com/gift/tag/global_banner.png"],
			"tagBanner": {
				"tagType": 1,
				"bg": "https://vochatapp.thevochat.com/gift/tag/banner/global_banner_en.png",
				"content": "The gift will trigger a global broadcast",
				"jumpUrl": "",
				"extData": ""
			},
			"translationKey": "key_gift_56"
		}, {
			"giftid": 57,
			"gold": 2200,
			"name": "Wedding Dress",
			"image": "https://falla-common.falla.live/119040-20200526_112814_1590463694253.png",
			"svga": "https://falla-common.falla.live/119040-20200315_215222_1584280342530.svga",
			"music": 2,
			"gifttype": 1,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://vochatapp.thevochat.com/gift/tag/global_banner.png"],
			"tagBanner": {
				"tagType": 1,
				"bg": "https://vochatapp.thevochat.com/gift/tag/banner/global_banner_en.png",
				"content": "The gift will trigger a global broadcast",
				"jumpUrl": "",
				"extData": ""
			},
			"translationKey": "key_gift_57"
		}, {
			"giftid": 224,
			"gold": 4999,
			"name": "Martyrs' Memorial",
			"image": "https://falla-res1.falla.live/119040-20210428_154007_1619595607045.png",
			"svga": "https://falla-res1.falla.live/119040-20201026_170950_1603703390554.svga",
			"music": 1,
			"gifttype": 2,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 2,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://vochatapp.thevochat.com/gift/tag/global_banner.png"],
			"tagBanner": {
				"tagType": 1,
				"bg": "https://vochatapp.thevochat.com/gift/tag/banner/global_banner_en.png",
				"content": "The gift will trigger a global broadcast",
				"jumpUrl": "",
				"extData": ""
			},
			"translationKey": "key_gift_224"
		}, {
			"giftid": 27,
			"gold": 13000,
			"name": "Merry",
			"image": "https://falla-common1.falla.live/gift/castle.png",
			"svga": "https://falla-common1.falla.live/gift/merry.svga",
			"music": 2,
			"gifttype": 2,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://falla-res.falla.live/785404-20210927_205317_1632747197573.png", "https://vochatapp.thevochat.com/gift/tag/global_banner.png"],
			"tagBanner": {
				"tagType": 5,
				"bg": "https://falla-res.falla.live/785404-20210927_205317_1632747197664.png",
				"content": "Send the gift to unlock",
				"jumpUrl": "vochat://medal/detail?medalKey=medal_love_king",
				"extData": "https://falla-sz.falla.live/545007-20200915_151746_1600154266753.png"
			},
			"translationKey": "key_gift_27"
		}, {
			"giftid": 179,
			"gold": 16999,
			"name": "pink castle",
			"image": "https://falla-res1.falla.live/119040-20210428_161101_1619597461451.png",
			"svga": "https://falla-res1.falla.live/119040-20200819_184800_1597834080519.svga",
			"music": 1,
			"gifttype": 2,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://vochatapp.thevochat.com/gift/tag/global_banner.png"],
			"tagBanner": {
				"tagType": 1,
				"bg": "https://vochatapp.thevochat.com/gift/tag/banner/global_banner_en.png",
				"content": "The gift will trigger a global broadcast",
				"jumpUrl": "",
				"extData": ""
			},
			"translationKey": "key_gift_179"
		}, {
			"giftid": 247,
			"gold": 50,
			"name": "Palestinian flag",
			"image": "https://falla-res1.falla.live/575685-20220512_194504_1652355904784.png",
			"svga": "",
			"music": 2,
			"gifttype": 0,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 2,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": [],
			"tagBanner": null,
			"translationKey": "key_gift_247"
		}, {
			"giftid": 286,
			"gold": 4999,
			"name": "Jaffa Clock Tower",
			"image": "https://falla-res1.falla.live/119040-20210428_163040_1619598640633.png",
			"svga": "https://falla-res1.falla.live/119040-20210115_190353_1610708633596.svga",
			"music": 1,
			"gifttype": 2,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 2,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://vochatapp.thevochat.com/gift/tag/global_banner.png"],
			"tagBanner": {
				"tagType": 1,
				"bg": "https://vochatapp.thevochat.com/gift/tag/banner/global_banner_en.png",
				"content": "The gift will trigger a global broadcast",
				"jumpUrl": "",
				"extData": ""
			},
			"translationKey": "key_gift_286"
		}, {
			"giftid": 86,
			"gold": 4999,
			"name": "boat",
			"image": "https://falla-res1.falla.live/119040-20210428_161448_1619597688658.png",
			"svga": "https://falla-common.falla.live/119040-20200315_225644_1584284204687.svga",
			"music": 1,
			"gifttype": 2,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://vochatapp.thevochat.com/gift/tag/global_banner.png"],
			"tagBanner": {
				"tagType": 1,
				"bg": "https://vochatapp.thevochat.com/gift/tag/banner/global_banner_en.png",
				"content": "The gift will trigger a global broadcast",
				"jumpUrl": "",
				"extData": ""
			},
			"translationKey": "key_gift_86"
		}, {
			"giftid": 326,
			"gold": 19999,
			"name": "Luxury yacht",
			"image": "https://falla-res1.falla.live/119040-20210428_160901_1619597341554.png",
			"svga": "https://falla-res1.falla.live/119040-20210326_173703_1616751423880.svga",
			"music": 2,
			"gifttype": 2,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://vochatapp.thevochat.com/gift/tag/global_banner.png"],
			"tagBanner": {
				"tagType": 1,
				"bg": "https://vochatapp.thevochat.com/gift/tag/banner/global_banner_en.png",
				"content": "The gift will trigger a global broadcast",
				"jumpUrl": "",
				"extData": ""
			},
			"translationKey": "key_gift_326"
		}, {
			"giftid": 125,
			"gold": 28000,
			"name": "sky castle",
			"image": "https://falla-res1.falla.live/119040-20210428_161113_1619597473612.png",
			"svga": "https://falla-res1.falla.live/119040-20200613_204854_1592052534702.svga",
			"music": 1,
			"gifttype": 2,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://falla-res.falla.live/785404-20210929_163427_1632904467973.png", "https://vochatapp.thevochat.com/gift/tag/global_banner.png"],
			"tagBanner": {
				"tagType": 5,
				"bg": "https://falla-res.falla.live/785404-20210929_163429_1632904469235.png",
				"content": "Send the gift to unlock",
				"jumpUrl": "vochat://medal/detail?medalKey=Sky_Castle",
				"extData": "https://falla-res.falla.live/785404-20210929_122504_1632889504504.png"
			},
			"translationKey": "key_gift_125"
		}, {
			"giftid": 20,
			"gold": 39999,
			"name": "Castle",
			"image": "https://falla-common1.falla.live/gift/castle2.png",
			"svga": "https://falla-common1.falla.live/gift/castle3.svga",
			"music": 2,
			"gifttype": 2,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://vochatapp.thevochat.com/gift/tag/global_banner.png"],
			"tagBanner": {
				"tagType": 1,
				"bg": "https://vochatapp.thevochat.com/gift/tag/banner/global_banner_en.png",
				"content": "The gift will trigger a global broadcast",
				"jumpUrl": "",
				"extData": ""
			},
			"translationKey": "key_gift_20"
		}, {
			"giftid": 150,
			"gold": 500,
			"name": "Immortal flower",
			"image": "https://falla-res1.falla.live/119040-20210428_160723_1619597243248.png",
			"svga": "https://falla-res1.falla.live/119040-20200717_212249_1594992169663.svga",
			"music": 2,
			"gifttype": 1,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": [],
			"tagBanner": null,
			"translationKey": "key_gift_150"
		}, {
			"giftid": 141,
			"gold": 4999,
			"name": "Mausoleum of Humayun",
			"image": "https://falla-res1.falla.live/119040-20210428_154027_1619595627816.png",
			"svga": "https://falla-res1.falla.live/119040-20200711_124243_1594442563456.svga",
			"music": 1,
			"gifttype": 2,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 2,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://vochatapp.thevochat.com/gift/tag/global_banner.png"],
			"tagBanner": {
				"tagType": 1,
				"bg": "https://vochatapp.thevochat.com/gift/tag/banner/global_banner_en.png",
				"content": "The gift will trigger a global broadcast",
				"jumpUrl": "",
				"extData": ""
			},
			"translationKey": "key_gift_141"
		}, {
			"giftid": 182,
			"gold": 8000,
			"name": "Ruby Ring",
			"image": "https://falla-res1.falla.live/119040-20200825_123204_1598329924044.png",
			"svga": "https://falla-res1.falla.live/575685-20220512_182634_1652351194303.svga",
			"music": 1,
			"gifttype": 2,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://vochatapp.thevochat.com/gift/tag/global_banner.png"],
			"tagBanner": {
				"tagType": 1,
				"bg": "https://vochatapp.thevochat.com/gift/tag/banner/global_banner_en.png",
				"content": "The gift will trigger a global broadcast",
				"jumpUrl": "",
				"extData": ""
			},
			"translationKey": "key_gift_182"
		}, {
			"giftid": 394,
			"gold": 10000,
			"name": "Dreamlike Wedding",
			"image": "https://falla-res1.falla.live/119040-20210712_112935_1626060575457.png",
			"svga": "https://falla-res1.falla.live/119040-20210713_122126_1626150086100.svga",
			"music": 1,
			"gifttype": 2,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://vochatapp.thevochat.com/gift/tag/global_banner.png"],
			"tagBanner": {
				"tagType": 1,
				"bg": "https://vochatapp.thevochat.com/gift/tag/banner/global_banner_en.png",
				"content": "The gift will trigger a global broadcast",
				"jumpUrl": "",
				"extData": ""
			},
			"translationKey": "key_gift_394"
		}, {
			"giftid": 187,
			"gold": 99999,
			"name": "ForeverLove",
			"image": "https://falla-res1.falla.live/100936-20200901_120215_1598932935241.png",
			"svga": "https://falla-res1.falla.live/119040-20210311_123018_1615437018668.svga",
			"music": 1,
			"gifttype": 2,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "https://vochat-sz.thevochat.com/100936-20200901_154653_1598946413259.png",
			"customType": 1,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://falla-res.falla.live/785404-20210929_163634_1632904594945.png", "https://vochatapp.thevochat.com/gift/tag/global_effect.png"],
			"tagBanner": {
				"tagType": 5,
				"bg": "https://falla-res.falla.live/785404-20210929_163636_1632904596914.png",
				"content": "Send the gift to unlock",
				"jumpUrl": "vochat://medal/detail?medalKey=foreverlove",
				"extData": "https://falla-res.falla.live/785404-20210929_122016_1632889216303.png"
			},
			"translationKey": "key_gift_187"
		}, {
			"giftid": 246,
			"gold": 50,
			"name": "Jordanian flag",
			"image": "https://falla-res1.falla.live/575685-20220512_194530_1652355930651.png",
			"svga": "",
			"music": 2,
			"gifttype": 0,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 2,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": [],
			"tagBanner": null,
			"translationKey": "key_gift_246"
		}, {
			"giftid": 222,
			"gold": 4999,
			"name": "Petra",
			"image": "https://falla-res1.falla.live/119040-20210428_154037_1619595637852.png",
			"svga": "https://falla-res1.falla.live/119040-20201026_170811_1603703291777.svga",
			"music": 1,
			"gifttype": 2,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 2,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://vochatapp.thevochat.com/gift/tag/global_banner.png"],
			"tagBanner": {
				"tagType": 1,
				"bg": "https://vochatapp.thevochat.com/gift/tag/banner/global_banner_en.png",
				"content": "The gift will trigger a global broadcast",
				"jumpUrl": "",
				"extData": ""
			},
			"translationKey": "key_gift_222"
		}, {
			"giftid": 26,
			"gold": 6666,
			"name": "Lamborghini",
			"image": "https://falla-res1.falla.live/119040-20210428_161947_1619597987772.png",
			"svga": "https://falla-common.falla.live/119040-20200315_221508_1584281708003.svga",
			"music": 1,
			"gifttype": 2,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://falla-res.falla.live/785404-20210929_162131_1632903691468.png", "https://vochatapp.thevochat.com/gift/tag/global_banner.png"],
			"tagBanner": {
				"tagType": 5,
				"bg": "https://falla-res.falla.live/785404-20210929_162134_1632903694979.png",
				"content": "Send the gift to unlock",
				"jumpUrl": "vochat://medal/detail?medalKey=Lamborghini",
				"extData": "https://falla-res.falla.live/785404-20210929_143957_1632897597048.png"
			},
			"translationKey": "key_gift_26"
		}, {
			"giftid": 19,
			"gold": 6999,
			"name": "Ferrari",
			"image": "https://falla-res1.falla.live/119040-20210428_161215_1619597535798.png",
			"svga": "https://falla-common.falla.live/119040-20200315_220226_1584280946109.svga",
			"music": 1,
			"gifttype": 2,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://falla-res.falla.live/785404-20210929_155233_1632901953002.png", "https://vochatapp.thevochat.com/gift/tag/global_banner.png"],
			"tagBanner": {
				"tagType": 5,
				"bg": "https://falla-res.falla.live/785404-20210929_155233_1632901953991.png",
				"content": "Send the gift to unlock",
				"jumpUrl": "vochat://medal/detail?medalKey=Ferrari",
				"extData": "https://falla-res.falla.live/785404-20210929_151233_1632899553311.png"
			},
			"translationKey": "key_gift_19"
		}, {
			"giftid": 22,
			"gold": 8888,
			"name": "Rocket",
			"image": "https://falla-res1.falla.live/119040-20210429_182327_1619691807475.png",
			"svga": "https://falla-res1.falla.live/119040-20210429_182330_1619691810284.svga",
			"music": 1,
			"gifttype": 2,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://falla-res.falla.live/785404-20210929_155959_1632902399974.png", "https://vochatapp.thevochat.com/gift/tag/global_banner.png"],
			"tagBanner": {
				"tagType": 5,
				"bg": "https://falla-res.falla.live/785404-20210929_160001_1632902401215.png",
				"content": "Send the gift to unlock",
				"jumpUrl": "vochat://medal/detail?medalKey=Rocket",
				"extData": "https://falla-res.falla.live/785404-20210929_150637_1632899197659.png"
			},
			"translationKey": "key_gift_22"
		}, {
			"giftid": 21,
			"gold": 9999,
			"name": "Plane",
			"image": "https://falla-res1.falla.live/119040-20210428_161328_1619597608475.png",
			"svga": "https://falla-common1.falla.live/gift/plane2.svga",
			"music": 2,
			"gifttype": 2,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://falla-res.falla.live/785404-20210929_155747_1632902267704.png", "https://vochatapp.thevochat.com/gift/tag/global_banner.png"],
			"tagBanner": {
				"tagType": 5,
				"bg": "https://falla-res.falla.live/785404-20210929_155748_1632902268513.png",
				"content": "Send the gift to unlock",
				"jumpUrl": "vochat://medal/detail?medalKey=Plane",
				"extData": "https://falla-res.falla.live/785404-20210929_151057_1632899457485.png"
			},
			"translationKey": "key_gift_21"
		}, {
			"giftid": 524,
			"gold": 499,
			"name": "Meteor Sword",
			"image": "https://falla-res1.falla.live/785404-20211104_165517_1636016117759.png",
			"svga": "https://falla-res1.falla.live/785404-20211104_165524_1636016124844.svga",
			"music": 2,
			"gifttype": 1,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": [],
			"tagBanner": null,
			"translationKey": "72_rpeaqqlmet"
		}, {
			"giftid": 856,
			"gold": 3333,
			"name": "Falla UFO",
			"image": "https://falla-res1.falla.live/785404-20220525_153327_1653464007213.png",
			"svga": "https://falla-res1.falla.live/785404-20220525_153335_1653464015747.mp4",
			"music": 2,
			"gifttype": 2,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://vochatapp.thevochat.com/gift/tag/3d.png", "https://vochatapp.thevochat.com/gift/tag/global_banner.png"],
			"tagBanner": {
				"tagType": 4,
				"bg": "https://vochatapp.thevochat.com/gift/tag/banner/3d_en.png",
				"content": "The gift will trigger 3D animation",
				"jumpUrl": "",
				"extData": ""
			},
			"translationKey": "72_ppvpedyduf"
		}, {
			"giftid": 223,
			"gold": 4999,
			"name": "Citadel of Aleppo",
			"image": "https://falla-res1.falla.live/119040-20210428_154051_1619595651968.png",
			"svga": "https://falla-res1.falla.live/119040-20201026_170903_1603703343267.svga",
			"music": 1,
			"gifttype": 2,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 2,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://vochatapp.thevochat.com/gift/tag/global_banner.png"],
			"tagBanner": {
				"tagType": 1,
				"bg": "https://vochatapp.thevochat.com/gift/tag/banner/global_banner_en.png",
				"content": "The gift will trigger a global broadcast",
				"jumpUrl": "",
				"extData": ""
			},
			"translationKey": "key_gift_223"
		}, {
			"giftid": 855,
			"gold": 5000,
			"name": "Golden Rocket",
			"image": "https://falla-res1.falla.live/785404-20220525_153125_1653463885621.png",
			"svga": "https://falla-res1.falla.live/785404-20220525_153121_1653463881081.mp4",
			"music": 2,
			"gifttype": 2,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://vochatapp.thevochat.com/gift/tag/3d.png", "https://vochatapp.thevochat.com/gift/tag/global_banner.png"],
			"tagBanner": {
				"tagType": 4,
				"bg": "https://vochatapp.thevochat.com/gift/tag/banner/3d_en.png",
				"content": "The gift will trigger 3D animation",
				"jumpUrl": "",
				"extData": ""
			},
			"translationKey": "72_lsyhcuupkl"
		}, {
			"giftid": 44,
			"gold": 8888,
			"name": "Ferris wheel",
			"image": "https://falla-common.falla.live/119040-20200216_220511_1581861911730.png",
			"svga": "https://falla-common1.falla.live/gift/ferriswheel.svga",
			"music": 2,
			"gifttype": 2,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://vochatapp.thevochat.com/gift/tag/global_banner.png"],
			"tagBanner": {
				"tagType": 1,
				"bg": "https://vochatapp.thevochat.com/gift/tag/banner/global_banner_en.png",
				"content": "The gift will trigger a global broadcast",
				"jumpUrl": "",
				"extData": ""
			},
			"translationKey": "key_gift_44"
		}, {
			"giftid": 238,
			"gold": 50,
			"name": "Libya flag",
			"image": "https://falla-res1.falla.live/575685-20220512_194555_1652355955887.png",
			"svga": "",
			"music": 2,
			"gifttype": 0,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 2,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": [],
			"tagBanner": null,
			"translationKey": "key_gift_238"
		}, {
			"giftid": 430,
			"gold": 600,
			"name": "Altın Sikke Tabancası ",
			"image": "https://falla-res1.falla.live/119040-20210816_122227_1629087747350.png",
			"svga": "https://falla-res1.falla.live/119040-20210816_122228_1629087748606.svga",
			"music": 2,
			"gifttype": 1,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": [],
			"tagBanner": null,
			"translationKey": "key_gift_430"
		}, {
			"giftid": 885,
			"gold": 3000,
			"name": "ID 96000",
			"image": "https://falla-res1.falla.live/575685-20220606_120302_1654488182243.png",
			"svga": "https://falla-res1.falla.live/575685-20220606_120305_1654488185742.svga",
			"music": 2,
			"gifttype": 2,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 3,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://vochatapp.thevochat.com/gift/tag/global_banner.png"],
			"tagBanner": {
				"tagType": 1,
				"bg": "https://vochatapp.thevochat.com/gift/tag/banner/global_banner_en.png",
				"content": "The gift will trigger a global broadcast",
				"jumpUrl": "",
				"extData": ""
			},
			"translationKey": "72_dnvuxkuact"
		}, {
			"giftid": 886,
			"gold": 3000,
			"name": "ID 23332",
			"image": "https://falla-res1.falla.live/575685-20220606_120359_1654488239032.png",
			"svga": "https://falla-res1.falla.live/575685-20220606_120402_1654488242778.svga",
			"music": 2,
			"gifttype": 2,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 3,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://vochatapp.thevochat.com/gift/tag/global_banner.png"],
			"tagBanner": {
				"tagType": 1,
				"bg": "https://vochatapp.thevochat.com/gift/tag/banner/global_banner_en.png",
				"content": "The gift will trigger a global broadcast",
				"jumpUrl": "",
				"extData": ""
			},
			"translationKey": "72_jmcukqgyaf"
		}, {
			"giftid": 887,
			"gold": 3000,
			"name": "ID 7031",
			"image": "https://falla-res1.falla.live/575685-20220606_120527_1654488327363.png",
			"svga": "https://falla-res1.falla.live/575685-20220606_120531_1654488331835.svga",
			"music": 2,
			"gifttype": 2,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 3,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://vochatapp.thevochat.com/gift/tag/global_banner.png"],
			"tagBanner": {
				"tagType": 1,
				"bg": "https://vochatapp.thevochat.com/gift/tag/banner/global_banner_en.png",
				"content": "The gift will trigger a global broadcast",
				"jumpUrl": "",
				"extData": ""
			},
			"translationKey": "72_qgtwgosjwc"
		}, {
			"giftid": 888,
			"gold": 3000,
			"name": "ID 17537",
			"image": "https://falla-res1.falla.live/575685-20220606_120618_1654488378105.png",
			"svga": "https://falla-res1.falla.live/575685-20220606_120624_1654488384043.svga",
			"music": 2,
			"gifttype": 2,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 3,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://vochatapp.thevochat.com/gift/tag/global_banner.png"],
			"tagBanner": {
				"tagType": 1,
				"bg": "https://vochatapp.thevochat.com/gift/tag/banner/global_banner_en.png",
				"content": "The gift will trigger a global broadcast",
				"jumpUrl": "",
				"extData": ""
			},
			"translationKey": "72_rbdjuwfymz"
		}, {
			"giftid": 316,
			"gold": 4999,
			"name": "Tripoli Castle",
			"image": "https://falla-res1.falla.live/119040-20210428_162806_1619598486674.png",
			"svga": "https://falla-res1.falla.live/119040-20210306_151306_1615014786159.svga",
			"music": 1,
			"gifttype": 2,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 2,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://vochatapp.thevochat.com/gift/tag/global_banner.png"],
			"tagBanner": {
				"tagType": 1,
				"bg": "https://vochatapp.thevochat.com/gift/tag/banner/global_banner_en.png",
				"content": "The gift will trigger a global broadcast",
				"jumpUrl": "",
				"extData": ""
			},
			"translationKey": "key_gift_316"
		}, {
			"giftid": 472,
			"gold": 4999,
			"name": "Latin american tower",
			"image": "https://falla-res1.falla.live/119040-20210923_164854_1632386934743.png",
			"svga": "https://falla-res1.falla.live/119040-20210923_164856_1632386936725.svga",
			"music": 2,
			"gifttype": 2,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 2,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://vochatapp.thevochat.com/gift/tag/global_banner.png"],
			"tagBanner": {
				"tagType": 1,
				"bg": "https://vochatapp.thevochat.com/gift/tag/banner/global_banner_en.png",
				"content": "The gift will trigger a global broadcast",
				"jumpUrl": "",
				"extData": ""
			},
			"translationKey": "key_gift_472"
		}, {
			"giftid": 13,
			"gold": 5,
			"name": "Sheep",
			"image": "https://falla-res1.falla.live/119040-20210428_181155_1619604715241.png",
			"svga": "",
			"music": 2,
			"gifttype": 0,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": [],
			"tagBanner": null,
			"translationKey": "key_gift_13"
		}, {
			"giftid": 54,
			"gold": 39,
			"name": "Crow",
			"image": "https://falla-res1.falla.live/119040-20210428_174550_1619603150237.png",
			"svga": "",
			"music": 2,
			"gifttype": 0,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": [],
			"tagBanner": null,
			"translationKey": "key_gift_54"
		}, {
			"giftid": 482,
			"gold": 39,
			"name": "Rooster",
			"image": "https://falla-res1.falla.live/119040-20211117_145121_1637131881049.png",
			"svga": "https://falla-res1.falla.live/575685-20220418_204612_1650285972800.svga",
			"music": 2,
			"gifttype": 1,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": [],
			"tagBanner": null,
			"translationKey": "key_gift_482"
		}, {
			"giftid": 43,
			"gold": 47,
			"name": "Donkey",
			"image": "https://falla-common.falla.live/119040-20200315_222009_1584282009778.png",
			"svga": "https://falla-res1.falla.live/575685-20220512_182942_1652351382382.svga",
			"music": 2,
			"gifttype": 1,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": [],
			"tagBanner": null,
			"translationKey": "key_gift_43"
		}, {
			"giftid": 488,
			"gold": 150,
			"name": "Cat",
			"image": "https://falla-res1.falla.live/785404-20211124_145530_1637736930532.png",
			"svga": "https://falla-res1.falla.live/575685-20220418_205040_1650286240533.svga",
			"music": 2,
			"gifttype": 1,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": [],
			"tagBanner": null,
			"translationKey": "key_gift_488"
		}, {
			"giftid": 529,
			"gold": 3000,
			"name": "Fire unicorn",
			"image": "https://falla-res1.falla.live/785404-20211104_170211_1636016531233.png",
			"svga": "https://falla-res1.falla.live/785404-20211104_170212_1636016532592.svga",
			"music": 2,
			"gifttype": 2,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://vochatapp.thevochat.com/gift/tag/global_banner.png"],
			"tagBanner": {
				"tagType": 1,
				"bg": "https://vochatapp.thevochat.com/gift/tag/banner/global_banner_en.png",
				"content": "The gift will trigger a global broadcast",
				"jumpUrl": "",
				"extData": ""
			},
			"translationKey": "72_yujqtiulmw"
		}, {
			"giftid": 42,
			"gold": 3333,
			"name": "Leopard",
			"image": "https://falla-common.falla.live/119040-20200526_113041_1590463841256.png",
			"svga": "https://falla-common.falla.live/119040-20200315_215738_1584280658574.svga",
			"music": 2,
			"gifttype": 2,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://falla-res.falla.live/785404-20210929_161637_1632903397973.png", "https://vochatapp.thevochat.com/gift/tag/global_banner.png"],
			"tagBanner": {
				"tagType": 5,
				"bg": "https://falla-res.falla.live/785404-20210929_161641_1632903401929.png",
				"content": "Send the gift to unlock",
				"jumpUrl": "vochat://medal/detail?medalKey=Leopard",
				"extData": "https://falla-res.falla.live/785404-20210929_145318_1632898398317.png"
			},
			"translationKey": "key_gift_42"
		}, {
			"giftid": 55,
			"gold": 3777,
			"name": "Lion",
			"image": "https://falla-common.falla.live/119040-20200526_113222_1590463942305.png",
			"svga": "https://falla-common.falla.live/119040-20200315_215843_1584280723100.svga",
			"music": 2,
			"gifttype": 2,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://falla-res.falla.live/785404-20210929_163049_1632904249036.png", "https://vochatapp.thevochat.com/gift/tag/global_banner.png"],
			"tagBanner": {
				"tagType": 5,
				"bg": "https://falla-res.falla.live/785404-20210929_163050_1632904250479.png",
				"content": "Send the gift to unlock",
				"jumpUrl": "vochat://medal/detail?medalKey=Lion",
				"extData": "https://falla-res.falla.live/785404-20210929_142021_1632896421627.png"
			},
			"translationKey": "key_gift_55"
		}, {
			"giftid": 396,
			"gold": 4999,
			"name": "BD National Memorial",
			"image": "https://falla-res1.falla.live/119040-20210714_115751_1626235071847.png",
			"svga": "https://falla-res1.falla.live/119040-20210714_115750_1626235070227.svga",
			"music": 1,
			"gifttype": 2,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 2,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://vochatapp.thevochat.com/gift/tag/global_banner.png"],
			"tagBanner": {
				"tagType": 1,
				"bg": "https://vochatapp.thevochat.com/gift/tag/banner/global_banner_en.png",
				"content": "The gift will trigger a global broadcast",
				"jumpUrl": "",
				"extData": ""
			},
			"translationKey": "key_gift_396"
		}, {
			"giftid": 836,
			"gold": 100,
			"name": "Cigarette",
			"image": "https://falla-res1.falla.live/575685-20220512_185635_1652352995638.png",
			"svga": "https://falla-res1.falla.live/575685-20220512_185700_1652353020336.svga",
			"music": 2,
			"gifttype": 1,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": [],
			"tagBanner": null,
			"translationKey": "72_wzdcbkrnug"
		}, {
			"giftid": 654,
			"gold": 188,
			"name": "hookah",
			"image": "https://falla-res1.falla.live/785404-20220127_144153_1643265713432.png",
			"svga": "https://falla-res1.falla.live/785404-20220127_144152_1643265712763.svga",
			"music": 2,
			"gifttype": 1,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": [],
			"tagBanner": null,
			"translationKey": "72_fzcfrlxmfu"
		}, {
			"giftid": 281,
			"gold": 300,
			"name": "Coffee",
			"image": "https://falla-res1.falla.live/119040-20210428_161542_1619597742829.png",
			"svga": "https://falla-res1.falla.live/119040-20210109_191648_1610191008824.svga",
			"music": 2,
			"gifttype": 1,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": [],
			"tagBanner": null,
			"translationKey": "key_gift_281"
		}, {
			"giftid": 378,
			"gold": 300,
			"name": "Raki",
			"image": "https://falla-res1.falla.live/119040-20210617_142956_1623911396475.png",
			"svga": "https://falla-res1.falla.live/119040-20210617_142958_1623911398620.svga",
			"music": 2,
			"gifttype": 1,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": [],
			"tagBanner": null,
			"translationKey": "key_gift_378"
		}, {
			"giftid": 299,
			"gold": 600,
			"name": "Crown",
			"image": "https://falla-res1.falla.live/119040-20210428_161603_1619597763407.png",
			"svga": "https://falla-res1.falla.live/119040-20210208_121458_1612757698578.svga",
			"music": 2,
			"gifttype": 1,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": [],
			"tagBanner": null,
			"translationKey": "key_gift_299"
		}, {
			"giftid": 872,
			"gold": 3000,
			"name": "ID 44026",
			"image": "https://falla-res1.falla.live/575685-20220601_164157_1654072917903.png",
			"svga": "https://falla-res1.falla.live/575685-20220601_164205_1654072925409.svga",
			"music": 2,
			"gifttype": 2,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 3,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://vochatapp.thevochat.com/gift/tag/global_banner.png"],
			"tagBanner": {
				"tagType": 1,
				"bg": "https://vochatapp.thevochat.com/gift/tag/banner/global_banner_en.png",
				"content": "The gift will trigger a global broadcast",
				"jumpUrl": "",
				"extData": ""
			},
			"translationKey": "72_wrodwdrfze"
		}, {
			"giftid": 873,
			"gold": 3000,
			"name": "ID 36933",
			"image": "https://falla-res1.falla.live/575685-20220601_164331_1654073011716.png",
			"svga": "https://falla-res1.falla.live/575685-20220601_164351_1654073031488.svga",
			"music": 2,
			"gifttype": 2,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 3,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://vochatapp.thevochat.com/gift/tag/global_banner.png"],
			"tagBanner": {
				"tagType": 1,
				"bg": "https://vochatapp.thevochat.com/gift/tag/banner/global_banner_en.png",
				"content": "The gift will trigger a global broadcast",
				"jumpUrl": "",
				"extData": ""
			},
			"translationKey": "72_vmpioszveh"
		}, {
			"giftid": 874,
			"gold": 3000,
			"name": "ID 1",
			"image": "https://falla-res1.falla.live/575685-20220601_164549_1654073149557.png",
			"svga": "https://falla-res1.falla.live/575685-20220601_164550_1654073150132.svga",
			"music": 2,
			"gifttype": 2,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 3,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://vochatapp.thevochat.com/gift/tag/global_banner.png"],
			"tagBanner": {
				"tagType": 1,
				"bg": "https://vochatapp.thevochat.com/gift/tag/banner/global_banner_en.png",
				"content": "The gift will trigger a global broadcast",
				"jumpUrl": "",
				"extData": ""
			},
			"translationKey": "72_boxlulcaai"
		}, {
			"giftid": 801,
			"gold": 4999,
			"name": "Travel round the world",
			"image": "https://falla-res1.falla.live/785404-20220420_100959_1650420599231.png",
			"svga": "https://falla-res1.falla.live/785404-20220425_171534_1650878134924.mp4",
			"music": 2,
			"gifttype": 2,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://vochatapp.thevochat.com/gift/tag/3d.png", "https://vochatapp.thevochat.com/gift/tag/global_banner.png"],
			"tagBanner": {
				"tagType": 4,
				"bg": "https://vochatapp.thevochat.com/gift/tag/banner/3d_en.png",
				"content": "The gift will trigger 3D animation",
				"jumpUrl": "",
				"extData": ""
			},
			"translationKey": "72_tjgbzlsnkf"
		}, {
			"giftid": 808,
			"gold": 15,
			"name": "Welcome",
			"image": "https://falla-res1.falla.live/575685-20220428_033428_1651088068658.png",
			"svga": "",
			"music": 2,
			"gifttype": 0,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": [],
			"tagBanner": null,
			"translationKey": "72_ldoarioyti"
		}, {
			"giftid": 284,
			"gold": 200,
			"name": "Make friend",
			"image": "https://falla-res1.falla.live/119040-20210428_161400_1619597640136.png",
			"svga": "https://falla-res1.falla.live/119040-20210115_175748_1610704668702.svga",
			"music": 2,
			"gifttype": 1,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://falla-res.falla.live/785404-20210929_161846_1632903526218.png"],
			"tagBanner": {
				"tagType": 5,
				"bg": "https://falla-res.falla.live/785404-20210929_161846_1632903526894.png",
				"content": "Send the gift to unlock",
				"jumpUrl": "vochat://medal/detail?medalKey=Make_Friend",
				"extData": "https://falla-res.falla.live/785404-20210929_145027_1632898227217.png"
			},
			"translationKey": "key_gift_284"
		}, {
			"giftid": 52,
			"gold": 1111,
			"name": "Cake",
			"image": "https://falla-res1.falla.live/119040-20210526_165054_1622019054346.png",
			"svga": "https://falla-res1.falla.live/119040-20210526_165055_1622019055529.svga",
			"music": 1,
			"gifttype": 1,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": [],
			"tagBanner": null,
			"translationKey": "key_gift_52"
		}, {
			"giftid": 875,
			"gold": 3000,
			"name": "ID 333001",
			"image": "https://falla-res1.falla.live/575685-20220601_164829_1654073309568.png",
			"svga": "https://falla-res1.falla.live/575685-20220601_164830_1654073310796.svga",
			"music": 2,
			"gifttype": 2,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 3,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://vochatapp.thevochat.com/gift/tag/global_banner.png"],
			"tagBanner": {
				"tagType": 1,
				"bg": "https://vochatapp.thevochat.com/gift/tag/banner/global_banner_en.png",
				"content": "The gift will trigger a global broadcast",
				"jumpUrl": "",
				"extData": ""
			},
			"translationKey": "72_bhfiqvrtcf"
		}, {
			"giftid": 876,
			"gold": 3000,
			"name": "ID 23332",
			"image": "https://falla-res1.falla.live/575685-20220601_164953_1654073393491.png",
			"svga": "https://falla-res1.falla.live/575685-20220601_164957_1654073397051.svga",
			"music": 2,
			"gifttype": 2,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 3,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://vochatapp.thevochat.com/gift/tag/global_banner.png"],
			"tagBanner": {
				"tagType": 1,
				"bg": "https://vochatapp.thevochat.com/gift/tag/banner/global_banner_en.png",
				"content": "The gift will trigger a global broadcast",
				"jumpUrl": "",
				"extData": ""
			},
			"translationKey": "72_jmcukqgyaf"
		}, {
			"giftid": 877,
			"gold": 3000,
			"name": "ID 7070",
			"image": "https://falla-res1.falla.live/575685-20220601_165337_1654073617340.png",
			"svga": "https://falla-res1.falla.live/575685-20220601_165349_1654073629446.svga",
			"music": 2,
			"gifttype": 2,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 3,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://vochatapp.thevochat.com/gift/tag/global_banner.png"],
			"tagBanner": {
				"tagType": 1,
				"bg": "https://vochatapp.thevochat.com/gift/tag/banner/global_banner_en.png",
				"content": "The gift will trigger a global broadcast",
				"jumpUrl": "",
				"extData": ""
			},
			"translationKey": "72_roirvbngyj"
		}, {
			"giftid": 136,
			"gold": 15,
			"name": "onion",
			"image": "https://falla-res1.falla.live/119040-20200702_204757_1593694077274.png",
			"svga": "",
			"music": 2,
			"gifttype": 0,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": [],
			"tagBanner": null,
			"translationKey": "key_gift_136"
		}, {
			"giftid": 293,
			"gold": 50,
			"name": "Lebanon flag",
			"image": "https://falla-res1.falla.live/575685-20220512_194626_1652355986187.png",
			"svga": "",
			"music": 2,
			"gifttype": 0,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 2,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": [],
			"tagBanner": null,
			"translationKey": "key_gift_293"
		}, {
			"giftid": 411,
			"gold": 50,
			"name": "Tunisia flag",
			"image": "https://falla-res1.falla.live/575685-20220512_194647_1652356007955.png",
			"svga": "",
			"music": 2,
			"gifttype": 0,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 2,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": [],
			"tagBanner": null,
			"translationKey": "key_gift_411"
		}, {
			"giftid": 112,
			"gold": 99,
			"name": "piñata",
			"image": "https://falla-res1.falla.live/10000-20211210_140944_1639116584774.png",
			"svga": "https://falla-res1.falla.live/10000-20211210_140947_1639116587213.svga",
			"music": 2,
			"gifttype": 1,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://vochatapp.thevochat.com/gift/tag/lucky.png"],
			"tagBanner": {
				"tagType": 3,
				"bg": "https://vochatapp.thevochat.com/gift/tag/banner/lucky_en.png",
				"content": "Send the gift to get a random gift",
				"jumpUrl": "",
				"extData": ""
			},
			"translationKey": "key_gift_112"
		}, {
			"giftid": 810,
			"gold": 300,
			"name": "Baklava",
			"image": "https://falla-res1.falla.live/575685-20220428_033749_1651088269710.png",
			"svga": "https://falla-res1.falla.live/575685-20220428_033751_1651088271929.svga",
			"music": 2,
			"gifttype": 1,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": [],
			"tagBanner": null,
			"translationKey": "72_fxhbbkzkwb"
		}, {
			"giftid": 878,
			"gold": 3000,
			"name": "ID 342744",
			"image": "https://falla-res1.falla.live/575685-20220601_165627_1654073787699.png",
			"svga": "https://falla-res1.falla.live/575685-20220601_165630_1654073790240.svga",
			"music": 2,
			"gifttype": 2,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 3,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://vochatapp.thevochat.com/gift/tag/global_banner.png"],
			"tagBanner": {
				"tagType": 1,
				"bg": "https://vochatapp.thevochat.com/gift/tag/banner/global_banner_en.png",
				"content": "The gift will trigger a global broadcast",
				"jumpUrl": "",
				"extData": ""
			},
			"translationKey": "72_cadbdzlwde"
		}, {
			"giftid": 879,
			"gold": 3000,
			"name": "ID 7",
			"image": "https://falla-res1.falla.live/575685-20220601_170102_1654074062224.png",
			"svga": "https://falla-res1.falla.live/575685-20220601_170110_1654074070255.svga",
			"music": 2,
			"gifttype": 2,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 3,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://vochatapp.thevochat.com/gift/tag/global_banner.png"],
			"tagBanner": {
				"tagType": 1,
				"bg": "https://vochatapp.thevochat.com/gift/tag/banner/global_banner_en.png",
				"content": "The gift will trigger a global broadcast",
				"jumpUrl": "",
				"extData": ""
			},
			"translationKey": "72_ghupjunfqd"
		}, {
			"giftid": 880,
			"gold": 3000,
			"name": "ID 40001",
			"image": "https://falla-res1.falla.live/575685-20220601_170319_1654074199524.png",
			"svga": "https://falla-res1.falla.live/575685-20220601_170324_1654074204248.svga",
			"music": 2,
			"gifttype": 2,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 3,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://vochatapp.thevochat.com/gift/tag/global_banner.png"],
			"tagBanner": {
				"tagType": 1,
				"bg": "https://vochatapp.thevochat.com/gift/tag/banner/global_banner_en.png",
				"content": "The gift will trigger a global broadcast",
				"jumpUrl": "",
				"extData": ""
			},
			"translationKey": "72_ukvugmbsyd"
		}, {
			"giftid": 896,
			"gold": 3000,
			"name": "ID 7777",
			"image": "https://falla-res1.falla.live/119040-20220608_164903_1654678143290.png",
			"svga": "https://falla-res1.falla.live/119040-20220608_164905_1654678145582.svga",
			"music": 2,
			"gifttype": 2,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 3,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://vochatapp.thevochat.com/gift/tag/global_banner.png"],
			"tagBanner": {
				"tagType": 1,
				"bg": "https://vochatapp.thevochat.com/gift/tag/banner/global_banner_en.png",
				"content": "The gift will trigger a global broadcast",
				"jumpUrl": "",
				"extData": ""
			},
			"translationKey": "key_gift_385"
		}, {
			"giftid": 897,
			"gold": 3000,
			"name": "ID 40001",
			"image": "https://falla-res1.falla.live/119040-20220608_164939_1654678179080.png",
			"svga": "https://falla-res1.falla.live/119040-20220608_164942_1654678182518.svga",
			"music": 2,
			"gifttype": 2,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 3,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://vochatapp.thevochat.com/gift/tag/global_banner.png"],
			"tagBanner": {
				"tagType": 1,
				"bg": "https://vochatapp.thevochat.com/gift/tag/banner/global_banner_en.png",
				"content": "The gift will trigger a global broadcast",
				"jumpUrl": "",
				"extData": ""
			},
			"translationKey": "72_ukvugmbsyd"
		}, {
			"giftid": 898,
			"gold": 3000,
			"name": "ID 7070",
			"image": "https://falla-res1.falla.live/119040-20220610_115448_1654833288373.png",
			"svga": "https://falla-res1.falla.live/119040-20220610_115449_1654833289833.svga",
			"music": 2,
			"gifttype": 2,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 3,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://vochatapp.thevochat.com/gift/tag/global_banner.png"],
			"tagBanner": {
				"tagType": 1,
				"bg": "https://vochatapp.thevochat.com/gift/tag/banner/global_banner_en.png",
				"content": "The gift will trigger a global broadcast",
				"jumpUrl": "",
				"extData": ""
			},
			"translationKey": "72_roirvbngyj"
		}, {
			"giftid": 324,
			"gold": 4999,
			"name": "Al-Aqsa Mosque",
			"image": "https://falla-res1.falla.live/119040-20210428_154153_1619595713492.png",
			"svga": "https://falla-res1.falla.live/119040-20210318_185540_1616064940173.svga",
			"music": 2,
			"gifttype": 2,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 2,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://vochatapp.thevochat.com/gift/tag/global_banner.png"],
			"tagBanner": {
				"tagType": 1,
				"bg": "https://vochatapp.thevochat.com/gift/tag/banner/global_banner_en.png",
				"content": "The gift will trigger a global broadcast",
				"jumpUrl": "",
				"extData": ""
			},
			"translationKey": "key_gift_324"
		}, {
			"giftid": 255,
			"gold": 4999,
			"name": "Rizal monument",
			"image": "https://falla-res1.falla.live/119040-20210428_154205_1619595725910.png",
			"svga": "https://falla-res1.falla.live/119040-20201204_192024_1607080824644.svga",
			"music": 1,
			"gifttype": 2,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 2,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://vochatapp.thevochat.com/gift/tag/global_banner.png"],
			"tagBanner": {
				"tagType": 1,
				"bg": "https://vochatapp.thevochat.com/gift/tag/banner/global_banner_en.png",
				"content": "The gift will trigger a global broadcast",
				"jumpUrl": "",
				"extData": ""
			},
			"translationKey": "key_gift_255"
		}, {
			"giftid": 217,
			"gold": 50,
			"name": "Turkish Flag",
			"image": "https://falla-res1.falla.live/575685-20220429_214210_1651239730633.png",
			"svga": "",
			"music": 2,
			"gifttype": 0,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 2,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": [],
			"tagBanner": null,
			"translationKey": "key_gift_217"
		}, {
			"giftid": 853,
			"gold": 2999,
			"name": "Flying Turkish Flag",
			"image": "https://falla-res1.falla.live/575685-20220524_211952_1653398392890.png",
			"svga": "https://falla-res1.falla.live/575685-20220524_211957_1653398397407.svga",
			"music": 2,
			"gifttype": 2,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 2,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://vochatapp.thevochat.com/gift/tag/global_banner.png"],
			"tagBanner": {
				"tagType": 1,
				"bg": "https://vochatapp.thevochat.com/gift/tag/banner/global_banner_en.png",
				"content": "The gift will trigger a global broadcast",
				"jumpUrl": "",
				"extData": ""
			},
			"translationKey": "72_jkswnaauze"
		}, {
			"giftid": 854,
			"gold": 3000,
			"name": "ID 3030",
			"image": "https://falla-res1.falla.live/119040-20220525_110446_1653447886751.png",
			"svga": "https://falla-res1.falla.live/119040-20220525_110447_1653447887983.svga",
			"music": 2,
			"gifttype": 2,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 3,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://vochatapp.thevochat.com/gift/tag/global_banner.png"],
			"tagBanner": {
				"tagType": 1,
				"bg": "https://vochatapp.thevochat.com/gift/tag/banner/global_banner_en.png",
				"content": "The gift will trigger a global broadcast",
				"jumpUrl": "",
				"extData": ""
			},
			"translationKey": "72_ekwtlfgoot"
		}, {
			"giftid": 902,
			"gold": 3000,
			"name": "CP NO.1",
			"image": "https://falla-res1.falla.live/575685-20220614_181749_1655201869874.png",
			"svga": "https://falla-res1.falla.live/575685-20220614_181753_1655201873152.svga",
			"music": 2,
			"gifttype": 2,
			"new": 1,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 3,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://vochatapp.thevochat.com/gift/tag/global_banner.png"],
			"tagBanner": {
				"tagType": 1,
				"bg": "https://vochatapp.thevochat.com/gift/tag/banner/global_banner_en.png",
				"content": "The gift will trigger a global broadcast",
				"jumpUrl": "",
				"extData": ""
			},
			"translationKey": "key_gift_513"
		}, {
			"giftid": 903,
			"gold": 3000,
			"name": "CP NO.1",
			"image": "https://falla-res1.falla.live/575685-20220614_182201_1655202121916.png",
			"svga": "https://falla-res1.falla.live/575685-20220614_182205_1655202125455.svga",
			"music": 2,
			"gifttype": 2,
			"new": 1,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 3,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://vochatapp.thevochat.com/gift/tag/global_banner.png"],
			"tagBanner": {
				"tagType": 1,
				"bg": "https://vochatapp.thevochat.com/gift/tag/banner/global_banner_en.png",
				"content": "The gift will trigger a global broadcast",
				"jumpUrl": "",
				"extData": ""
			},
			"translationKey": "key_gift_513"
		}, {
			"giftid": 904,
			"gold": 3000,
			"name": "CP NO.1",
			"image": "https://falla-res1.falla.live/575685-20220614_182251_1655202171298.png",
			"svga": "https://falla-res1.falla.live/575685-20220614_182256_1655202176816.svga",
			"music": 2,
			"gifttype": 2,
			"new": 1,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 3,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://vochatapp.thevochat.com/gift/tag/global_banner.png"],
			"tagBanner": {
				"tagType": 1,
				"bg": "https://vochatapp.thevochat.com/gift/tag/banner/global_banner_en.png",
				"content": "The gift will trigger a global broadcast",
				"jumpUrl": "",
				"extData": ""
			},
			"translationKey": "key_gift_513"
		}, {
			"giftid": 905,
			"gold": 3000,
			"name": "CP NO.1",
			"image": "https://falla-res1.falla.live/575685-20220614_182353_1655202233968.png",
			"svga": "https://falla-res1.falla.live/575685-20220614_182357_1655202237503.svga",
			"music": 2,
			"gifttype": 2,
			"new": 1,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 3,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://vochatapp.thevochat.com/gift/tag/global_banner.png"],
			"tagBanner": {
				"tagType": 1,
				"bg": "https://vochatapp.thevochat.com/gift/tag/banner/global_banner_en.png",
				"content": "The gift will trigger a global broadcast",
				"jumpUrl": "",
				"extData": ""
			},
			"translationKey": "key_gift_513"
		}, {
			"giftid": 142,
			"gold": 4999,
			"name": "Hagia Sophia",
			"image": "https://falla-res1.falla.live/119040-20210428_153814_1619595494594.png",
			"svga": "https://falla-res1.falla.live/119040-20200731_101601_1596161761905.svga",
			"music": 1,
			"gifttype": 2,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 2,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://vochatapp.thevochat.com/gift/tag/global_banner.png"],
			"tagBanner": {
				"tagType": 1,
				"bg": "https://vochatapp.thevochat.com/gift/tag/banner/global_banner_en.png",
				"content": "The gift will trigger a global broadcast",
				"jumpUrl": "",
				"extData": ""
			},
			"translationKey": "key_gift_142"
		}, {
			"giftid": 84,
			"gold": 17,
			"name": "cat paw",
			"image": "https://falla-common.falla.live/119040-20200315_224046_1584283246717.png",
			"svga": "",
			"music": 2,
			"gifttype": 0,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": [],
			"tagBanner": null,
			"translationKey": "key_gift_84"
		}, {
			"giftid": 151,
			"gold": 18,
			"name": "Surstromming",
			"image": "https://falla-res1.falla.live/119040-20200717_212407_1594992247187.png",
			"svga": "",
			"music": 2,
			"gifttype": 0,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": [],
			"tagBanner": null,
			"translationKey": "key_gift_151"
		}, {
			"giftid": 221,
			"gold": 20,
			"name": "Candy",
			"image": "https://falla-res1.falla.live/119040-20201030_211007_1604063407663.png",
			"svga": "",
			"music": 2,
			"gifttype": 0,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": [],
			"tagBanner": null,
			"translationKey": "key_gift_221"
		}, {
			"giftid": 508,
			"gold": 20,
			"name": "Ghost",
			"image": "https://falla-res1.falla.live/119040-20211029_110213_1635476533891.png",
			"svga": "",
			"music": 2,
			"gifttype": 0,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": [],
			"tagBanner": null,
			"translationKey": "key_gift_508"
		}, {
			"giftid": 61,
			"gold": 39,
			"name": "celebrate",
			"image": "https://falla-common.falla.live/105490-20191230_191345_1577704425339.png",
			"svga": "https://falla-common.falla.live/105490-20191230_191347_1577704427439.svga",
			"music": 2,
			"gifttype": 1,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": [],
			"tagBanner": null,
			"translationKey": "key_gift_61"
		}, {
			"giftid": 85,
			"gold": 47,
			"name": "good",
			"image": "https://falla-common.falla.live/119040-20200315_224856_1584283736705.png",
			"svga": "",
			"music": 2,
			"gifttype": 0,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": [],
			"tagBanner": null,
			"translationKey": "key_gift_85"
		}, {
			"giftid": 688,
			"gold": 50,
			"name": "Mask",
			"image": "https://falla-res1.falla.live/575685-20220217_190204_1645095724305.png",
			"svga": "https://falla-res1.falla.live/575685-20220217_190207_1645095727805.svga",
			"music": 2,
			"gifttype": 1,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": [],
			"tagBanner": null,
			"translationKey": "72_alvnycchce"
		}, {
			"giftid": 467,
			"gold": 50,
			"name": "Mexican flag",
			"image": "https://falla-res1.falla.live/575685-20220512_194711_1652356031253.png",
			"svga": "",
			"music": 2,
			"gifttype": 0,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 2,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": [],
			"tagBanner": null,
			"translationKey": "key_gift_467"
		}, {
			"giftid": 477,
			"gold": 50,
			"name": "Uruguay flag",
			"image": "https://falla-res1.falla.live/575685-20220512_194736_1652356056894.png",
			"svga": "",
			"music": 2,
			"gifttype": 0,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 2,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": [],
			"tagBanner": null,
			"translationKey": "key_gift_477"
		}, {
			"giftid": 478,
			"gold": 50,
			"name": "Colombian flag",
			"image": "https://falla-res1.falla.live/575685-20220512_194802_1652356082081.png",
			"svga": "",
			"music": 2,
			"gifttype": 0,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 2,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": [],
			"tagBanner": null,
			"translationKey": "key_gift_478"
		}, {
			"giftid": 479,
			"gold": 50,
			"name": "Argentina flag",
			"image": "https://falla-res1.falla.live/575685-20220512_194823_1652356103811.png",
			"svga": "",
			"music": 2,
			"gifttype": 0,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 2,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": [],
			"tagBanner": null,
			"translationKey": "key_gift_479"
		}, {
			"giftid": 480,
			"gold": 50,
			"name": "Chilean flag",
			"image": "https://falla-res1.falla.live/575685-20220512_194853_1652356133636.png",
			"svga": "",
			"music": 2,
			"gifttype": 0,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 2,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": [],
			"tagBanner": null,
			"translationKey": "key_gift_480"
		}, {
			"giftid": 481,
			"gold": 50,
			"name": "Spanish flag",
			"image": "https://falla-res1.falla.live/575685-20220512_194913_1652356153585.png",
			"svga": "",
			"music": 2,
			"gifttype": 0,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 2,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": [],
			"tagBanner": null,
			"translationKey": "key_gift_481"
		}, {
			"giftid": 490,
			"gold": 50,
			"name": "Flag of Azerbaijan",
			"image": "https://falla-res1.falla.live/575685-20220429_214343_1651239823680.png",
			"svga": "",
			"music": 2,
			"gifttype": 0,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 2,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": [],
			"tagBanner": null,
			"translationKey": "key_gift_490"
		}, {
			"giftid": 594,
			"gold": 77,
			"name": "uvas del año",
			"image": "https://falla-res1.falla.live/119040-20211220_164750_1639990070982.png",
			"svga": "https://falla-res1.falla.live/119040-20211220_164752_1639990072551.svga",
			"music": 2,
			"gifttype": 1,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": [],
			"tagBanner": null,
			"translationKey": "72_qwchgxdldn"
		}, {
			"giftid": 331,
			"gold": 200,
			"name": "Box",
			"image": "https://falla-res1.falla.live/119040-20210329_115432_1616990072313.png",
			"svga": "https://falla-res1.falla.live/119040-20210329_115739_1616990259584.svga",
			"music": 2,
			"gifttype": 1,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": [],
			"tagBanner": null,
			"translationKey": "key_gift_331"
		}, {
			"giftid": 431,
			"gold": 1000,
			"name": "Heart Diamond",
			"image": "https://falla-res1.falla.live/119040-20210816_122337_1629087817502.png",
			"svga": "https://falla-res1.falla.live/119040-20210816_122339_1629087819116.svga",
			"music": 2,
			"gifttype": 1,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": [],
			"tagBanner": null,
			"translationKey": "key_gift_431"
		}, {
			"giftid": 16,
			"gold": 1314,
			"name": "Fireworks",
			"image": "https://falla-common1.falla.live/gift/fireworks1.png",
			"svga": "https://falla-common1.falla.live/gift/fireworks1.svga",
			"music": 2,
			"gifttype": 1,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": [],
			"tagBanner": null,
			"translationKey": "key_gift_16"
		}, {
			"giftid": 504,
			"gold": 3000,
			"name": "Princess dress",
			"image": "https://falla-res1.falla.live/119040-20211013_103127_1634092287852.png",
			"svga": "https://falla-res1.falla.live/119040-20211013_103134_1634092294103.svga",
			"music": 2,
			"gifttype": 2,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://falla-res.falla.live/119040-20211022_104313_1634870593925.png", "https://vochatapp.thevochat.com/gift/tag/global_banner.png"],
			"tagBanner": {
				"tagType": 7,
				"bg": "https://falla-res.falla.live/575685-20220526_114104_1653536464245.png",
				"content": ".",
				"jumpUrl": "https://web.falla.live/falla-web/micro-main/index.html?translateId=184\u0026countryId=144\u0026pageConfigId=96#/act-national-day",
				"extData": ""
			},
			"translationKey": "key_gift_504"
		}, {
			"giftid": 483,
			"gold": 4999,
			"name": "Colpatria tower",
			"image": "https://falla-res1.falla.live/119040-20210926_211446_1632662086304.png",
			"svga": "https://falla-res1.falla.live/119040-20210926_211449_1632662089177.svga",
			"music": 2,
			"gifttype": 2,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 2,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://vochatapp.thevochat.com/gift/tag/global_banner.png"],
			"tagBanner": {
				"tagType": 1,
				"bg": "https://vochatapp.thevochat.com/gift/tag/banner/global_banner_en.png",
				"content": "The gift will trigger a global broadcast",
				"jumpUrl": "",
				"extData": ""
			},
			"translationKey": "key_gift_483"
		}, {
			"giftid": 390,
			"gold": 5000,
			"name": "Flying Saucer",
			"image": "https://falla-res1.falla.live/119040-20210712_112440_1626060280092.png",
			"svga": "https://falla-res1.falla.live/119040-20210713_121942_1626149982547.svga",
			"music": 1,
			"gifttype": 2,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://vochatapp.thevochat.com/gift/tag/global_banner.png"],
			"tagBanner": {
				"tagType": 1,
				"bg": "https://vochatapp.thevochat.com/gift/tag/banner/global_banner_en.png",
				"content": "The gift will trigger a global broadcast",
				"jumpUrl": "",
				"extData": ""
			},
			"translationKey": "key_gift_390"
		}, {
			"giftid": 689,
			"gold": 5000,
			"name": "Float Parade",
			"image": "https://falla-res1.falla.live/575685-20220223_021926_1645553966717.png",
			"svga": "https://falla-res1.falla.live/575685-20220218_125602_1645160162280.svga",
			"music": 2,
			"gifttype": 2,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://falla-res.falla.live/119040-20211022_104313_1634870593925.png", "https://vochatapp.thevochat.com/gift/tag/global_banner.png"],
			"tagBanner": {
				"tagType": 7,
				"bg": "https://falla-res.falla.live/575685-20220526_114104_1653536464245.png",
				"content": ".",
				"jumpUrl": "https://web.falla.live/falla-web/micro-main/index.html?translateId=184\u0026countryId=144\u0026pageConfigId=96#/act-national-day",
				"extData": ""
			},
			"translationKey": "72_zmmjyrvycq"
		}, {
			"giftid": 71,
			"gold": 7777,
			"name": "Surprise box",
			"image": "https://falla-common.falla.live/105716-20200122_145514_1579676114510.png",
			"svga": "https://falla-common.falla.live/105716-20200122_145525_1579676125068.svga",
			"music": 2,
			"gifttype": 2,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://vochatapp.thevochat.com/gift/tag/global_banner.png"],
			"tagBanner": {
				"tagType": 1,
				"bg": "https://vochatapp.thevochat.com/gift/tag/banner/global_banner_en.png",
				"content": "The gift will trigger a global broadcast",
				"jumpUrl": "",
				"extData": ""
			},
			"translationKey": "key_gift_71"
		}, {
			"giftid": 214,
			"gold": 50000,
			"name": "Dream Castle",
			"image": "https://falla-res1.falla.live/119040-20201019_160029_1603094429830.png",
			"svga": "https://falla-res1.falla.live/119040-20201019_160034_1603094434600.svga",
			"music": 1,
			"gifttype": 2,
			"new": 2,
			"weekStarUserImage": "",
			"tag": "",
			"customType": 0,
			"giftCategory": 1,
			"cp": 2,
			"vip": 0,
			"vipIcon": "",
			"tags": ["https://vochatapp.thevochat.com/gift/tag/global_banner.png"],
			"tagBanner": {
				"tagType": 1,
				"bg": "https://vochatapp.thevochat.com/gift/tag/banner/global_banner_en.png",
				"content": "The gift will trigger a global broadcast",
				"jumpUrl": "",
				"extData": ""
			},
			"translationKey": "key_gift_214"
		}]
		return (
			<div className="test">
				<table>
					{gifts.map((r, i) => {
						return <tr><td>{r.name}</td><td>{r.gold}</td><td>{r.vip > 0 ? 'vip' + r.vip : ''}</td><td><img src={r.image} /></td><td>{r.svga}</td></tr>
					})}
				</table>

			</div>
		)
	}
}



// WEBPACK FOOTER //
// src/pages/test/test/index.js